<div class="slide-prestation" [ngStyle]="{'width': '100%'}" (click)="findCalendar($event);">
  <div id="slide-left" *ngIf="showLeft">
    <div style="height: 60px;" [ngStyle]="{'padding-left': editContenant ? '20px' : '70px'}"
      *ngIf="!isModifierLeContenant && !modifContenantGrp">
      <div class="title-presatation" *ngIf="!edit"> Nouvelle prestation </div>
      <div class="title-presatation" *ngIf="edit"> Modification prestation </div>
    </div>
    <div style="padding-left: 70px;height: 60px;" *ngIf="isModifierLeContenant || modifContenantGrp">
      <div class="title-presatation"> Modification du contenant </div>
    </div>
    <div class="col-sm-12" style="height:calc(100% - 70px)">
      <div class="col-sm-1" style="padding:5px;"
        *ngIf="(!isModifierLeContenant || !modifContenantGrp || (isModifierLeContenant && afficherAutreStep && modifContenantGrp)) && !editContenant">
        <ul style="padding-left:0px;">
          <li>
            <span style="color: #376194;font-size: 19px;font-weight: 700;">{{step}}</span> <span
              style="color: black ;">/9</span>
          </li>
        </ul>
      </div>
      <div class="col-sm-1" style="padding:5px;"
        *ngIf="isModifierLeContenant && !afficherAutreStep && !editContenant&& !modifContenantGrp">
        <ul style="padding-left:0px;">
          <li>
            <span style="color: #376194;font-size: 19px;font-weight: 700;">{{step}}</span> <span
              style="color: black ;">/9</span>
          </li>
        </ul>
      </div>

      <div class="" style="height:100%;" [ngClass]="{'col-sm-11': !editContenant, 'col-sm-12 p-0': editContenant}">

        <div style="height: 0; overflow: hidden;">
          <input type="text" class="" id="inputTypeHidden" autocomplete="off" (keyup.enter)="keyEnterHideInput();">
        </div>

        <div class="add-prestation"
          *ngIf="!modifContenantGrp && (!isModifierLeContenant || (isModifierLeContenant && afficherAutreStep))"
          [ngSwitch]="step">
          <div class="col-sm-12" style="padding: 5px; height:100%">

            <div *ngSwitchCase="1" class="etape1">
              <div style="margin-bottom: 20px">
                <span class="step-title">Recherchez le client</span>
              </div>
              <div class="form-group">
                <app-autocomplete *ngIf="!newprest.showcombo" [placeholder]="'Nom et prénom du client *'"
                  (searchfunction)="objectFocus.client = true;searchClient($event)"
                  (selectfunction)="setValue($event, 'client');" [defaultselected]="newprest.client"
                  [results]="dataClient" [label]="'Nom et prénom du client *'"
                  [defaultsearch]="newprest.client ? (newprest.client.libelleObjetEntite || '') : ''" [minlength]="3">
                </app-autocomplete>
              </div>
              <label class="text" id="okshowFicheCltadd" style=" margin-top: 15px;padding-left: 0px;"
                [ngStyle]="{'margin-top': objectFocus.client ? '170px' : '15px'}" (click)="showFicheCltadd()">
                Voulez-vous
                <span class='text-underline uppercase'>creer un Client</span> ?</label>
              <div class="uppercase" id="okSearchcli"
                [ngStyle]="{'margin': newprest.showcombo ? '20px 0px' : '80px 0px'}">
                <button class="btn-ok" (click)="newprest.client ? nextStep(true) : setValue($event, 'client')">
                  OK
                </button>
                <label>Appuyez sur
                  <b>Entrée</b> pour valider.</label>
              </div>
            </div>
            <div *ngSwitchCase="2" class="etape2">
              <div style="margin-bottom: 15px">
                <span class="step-title">Sélectionnez le chantier</span>
              </div>
              <div class="form-group col-sm-12" style="padding: 0;" [ngClass]="{'disabledbutton': edit}">
                <app-autocomplete [placeholder]="'Chantier *'"
                  (searchfunction)="objectFocus.chantier = true;searchChantier($event)"
                  (selectfunction)=" selectedChantier = $event;setValue($event, 'chantier', false, false, true);objectFocus.lieu = {id: 0};objectFocus.chantier = false;"
                  [defaultselected]="newprest.chantier" [results]="listChantier" [label]="'Chantier *'"
                  [defaultsearch]="newprest.chantier ? newprest.chantier.numChantier : ''"
                  [disablefocus]="edit ? true : false" [autoshow]="edit ? false : true">
                </app-autocomplete>
              </div>


              <!-- natambatra -->
              <div class="col-sm-12" style="margin-bottom: 15px;padding: 0;">
                <span class="step-title"> Vérifier l'adresse du chantier </span>
              </div>
              <div class="list-group col-sm-12" style="padding: 0px;height: auto;background: #FFFFFF 0% 0% no-repeat padding-box;
              box-shadow: 0px 3px 0px #5393E0;
              border-radius: 5px;">
                <li class="list-group-item container" id="autofocus" tabindex="0" *ngIf="selectedChantier"
                  (keyup.enter)="setValue('test', 'adresse')" style="height: auto;min-height: 47px;
                  padding: 5px 8px;
                  font-size: 13px;">
                  <span class="col-sm-12 p-0">
                    <div> {{selectedChantier.adresse1 || ''}}</div>
                    <div> {{selectedChantier.adresse2 || ''}}</div>
                    <div> {{selectedChantier.adresse3 || ''}}</div>
                    <div> {{ (selectedChantier.codePostal || '') + ' ' + (selectedChantier.ville ||
                      '') }}</div>
                    <div> {{ (selectedChantier.telephone || '') }} </div>
                  </span>
                </li>
              </div>
              <label class="form-group text col-sm-12" id="btnAddNChant"  *ngIf="common.isCMchantier" style=" margin-top: 90px;padding: 0px;"
                [ngStyle]="{'margin-top': '25px'}" [ngClass]="{'disabledbutton': edit}"
                (click)="getChantier(false)">Voulez-vous
                <span class='text-underline uppercase'>creer un chantier</span> ?</label>

              <label class="text col-sm-12" id="btnEditChant" *ngIf="common.isCMchantier" style=" margin-top: 0px;padding: 0px;"
                (click)="getChantier((selectedChantier.id), true)">Voulez-vous
                <span class='text-underline uppercase'>modifier l'adresse du chantier</span> ?</label>
              
                <label class="form-group text col-sm-12" id="btnAddNChant" style=" margin-top: 90px;padding: 0px;"
                *ngIf="!common.isCMchantier" [ngStyle]="{'margin-top': '25px'}"></label>

              <div class="form-group items col-sm-12" id="conteneurLieu" style="padding: 0">
                <app-autocomplete (searchfunction)="objectFocus.lieu = true; searchZone($event)" [results]="resultZone"
                  [highlight]="true" [placeholder]="societe.clientCollectivite ? 'Circuit' : 'Lieu'"
                  [label]="societe.clientCollectivite ? 'Circuit' : 'Lieu'" [isCombo]="true" [disablefocus]="true"
                  [id]="'idLieu'" [notLoading]="true" [defaultselected]="newprest.lieu"
                  [defaultsearch]="newprest.lieu ? newprest.lieu.libelleObjetEntite || '' : ''"
                  (selectfunction)="objectFocus.lieu = false;setValue($event, 'lieu');;">
                </app-autocomplete>
              </div>

              <div class="uppercase col-sm-12 " style="padding: 0;margin: 20px 0px 0px;">
                <button class="btn-ok" id="okChantier" (click)="setValue(selectedChantier, 'chantier');
                ">
                  OK
                </button>
                <label>Appuyez sur
                  <b>Entrée</b> pour valider.</label>
              </div>
            </div>
            <div *ngSwitchCase="addContenant && !isGroupe ? 4 : 3" class="etape4 choixContenant" style="height: 100%;">
              <div *ngIf="!isGroupe && !modifierGroupe"
                [ngStyle]="{'height': !isGroupe && !newprest.IsAfficheNewContenant && !addArticle ? 'auto': '100%'}">
                <div style="margin-bottom: 10px">
                  <span class="step-title" *ngIf="!newprest.IsAfficheNewContenant && !addArticle && !isEditContenant">
                    Choix du contenant </span>
                  <span class="step-title" *ngIf="newprest.IsAfficheNewContenant && !addArticle "> Ajouter un
                    contenant </span>

                  <span class="step-title" *ngIf="addArticle"> Groupe d'article </span>
                </div>
                <mat-checkbox [color]="'primary'" [(ngModel)]="isGroupe" (ngModelChange)="showGroupeContenant()"
                  *ngIf="isCreateWithBtn && !newprest.IsAfficheNewContenant && !addArticle && !isEditContenant">
                  <label>Groupe contenant</label>
                </mat-checkbox>
                <div *ngIf="!newprest.IsAfficheNewContenant && !addArticle && !isEditContenant">

                  <div class="col-sm-12 p-0" [ngClass]="{'disabledbutton': addContenant }">
                    <app-autocomplete [placeholder]="'Choisir un contenant déjà crée'" [id]="'ChoiceContent'"
                      [isCombo]="true" (searchfunction)="listContenantCree($event,listcontenant)"
                      [results]="listeContent" [label]="''" (selectfunction)="ChoixContent($event)"
                      [defaultselected]="selectContenant" [container]="true" [selectvalue]="true"
                      [dropdownclass]="'maxZindex'" [defaultsearch]="">
                    </app-autocomplete>
                  </div>
                  <label class="text" [ngClass]="{'disabledbutton': addContenant }"
                    style=" margin-top: 15px;padding-left: 0px;" id="btnCreatContenant" (click)="showCreate()">
                    <span class='text-underline uppercase'> ajouter un contenant </span></label>

                </div>
                <div *ngIf="newprest.IsAfficheNewContenant && !addArticle"
                  style="height: calc(100% - 45px); overflow-y: auto;">
                  <div class="col-sm-12"
                    style="padding: 0; max-height: calc(100% - 100px);height: auto; overflow-y: auto;">
                    <div class="form-group">
                      <app-autocomplete
                        (selectfunction)="newBenne.typeContenant = $event; common.focusElement('.articleCont'); newBenne.qteContenant = 1; actualiseCont(newBenne)"
                        [results]="typeContenant" [highlight]="true" [showonclick]="true"
                        (searchfunction)="objectFocus.typeContenant = true; searchTypecontenantByLibelle($event)"
                        [label]="'Type contenant'" id="typecontenant" [placeholder]="'Type contenant'"
                        (keyenterfunction)="common.focusElement('.articleCont')" [container]="true"
                        [defaultselected]="newBenne.typeContenant"
                        [defaultsearch]="newBenne.typeContenant ? newBenne.typeContenant.libelleObjetEntite : ''">
                      </app-autocomplete>
                    </div>
                    <div class="form-group" *ngIf="!newBenne.isGroupeArticle">
                      <app-autocomplete [placeholder]="'Article'" id="articleCont"
                        (searchfunction)="objectFocus.article = true;searchArticle($event)"
                        (selectfunction)="newBenne.art = $event;   actualiseArt(newBenne.art, newBenne); (newBenne.typeContenant && !newBenne.typeContenant.isUnitaire) ? common.focusElement('.qteContenant') : common.focusElement('.checkbox-1-1')  "
                        [results]="listArticle" [label]="'Article'" [defaultselected]="newBenne.art" [container]="true"
                        (keyenterfunction)=" (newBenne.typeContenant && !newBenne.typeContenant.isUnitaire) ? common.focusElement('.qteContenant') : common.focusElement('.checkbox-1-1')"
                        [defaultsearch]="newBenne.art ? newBenne.art.libelleObjetEntite : ''">
                      </app-autocomplete>
                    </div>
                    <div class="form-group" *ngIf="societe.qtePrevisionnelle && !newBenne.isGroupeArticle">
                      <label *ngIf="newBenne.qte || newprest.qtefocus" style="position: absolute">
                        Qté Prev </label>
                      <input type="number" step="1" class="form-control info" id="qte" placeholder="Qté Prev" autofocus
                        [(ngModel)]="newBenne.qte" (focus)="newprest.qtefocus = true;"
                        [ngClass]="{'noValue': !newBenne.qte && !newprest.qtefocus}" (blur)="newprest.qtefocus = false;"
                        autocomplete="off">
                    </div>
                    <div class="form-group" *ngIf="newBenne.typeContenant && !newBenne.typeContenant.isUnitaire">
                      <label *ngIf="newBenne.qteContenant || newprest.qteContenantfocus" style="position: absolute">
                        Quantité contenant </label>
                      <input type="number" step="1" class="form-control info" id="qteContenant"
                        placeholder="Quantité contenant" autofocus [(ngModel)]="newBenne.qteContenant"
                        (keyup.enter)="setValue(newBenne, 'newBenne')" (focus)="newprest.qteContenantfocus = true;"
                        [ngClass]="{'noValue': !newBenne.qteContenant && !newprest.qteContenantfocus}"
                        (blur)="newprest.qteContenantfocus = false;" autocomplete="off">
                    </div>
                    <div class="form-group" *ngIf="societe.axeAnalytiqueLigneBon">
                      <label *ngIf="newBenne.axeAnalytiqueLigne || newBenne.axeAnalytiqueLignefocus"
                        style="position: absolute">
                        Axe ana. Prest </label>
                      <input type="text" class="form-control info" id="axeAnalytiqueLigne" placeholder="Axe ana. Prest"
                        autofocus [(ngModel)]="newBenne.axeAnalytiqueLigne"
                        (keyup.enter)="setValue(newBenne, 'newBenne')"
                        (focus)="newBenne.axeAnalytiqueLignefocus = true;"
                        [ngClass]="{'noValue': !newBenne.axeAnalytiqueLigne && !newprest.axeAnalytiqueLignefocus}"
                        (blur)="newBenne.axeAnalytiqueLignefocus = false;" autocomplete="off">
                    </div>

                    <div class="form-group" *ngIf="societe.groupeArticleEcobennes"
                      [ngStyle]="{'margin-top': objectFocus.typeContenant && newBenne.isGroupeArticle ? '190px' : '0px'}">
                      <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
                        [(ngModel)]="newBenne.isGroupeArticle" (ngModelChange)="newBenne.art = {}">
                      <span (click)="newBenne.isGroupeArticle = !newBenne.isGroupeArticle" style="cursor: pointer;">
                        Groupe </span>
                      <label class="text pull-right" *ngIf="newBenne.isGroupeArticle" style=" margin: 0px;padding: 0px;"
                        (click)="showArticleGrp();addArticlesNewBenne()">
                        <span class='text-underline uppercase'> ajouter un article
                        </span></label>
                    </div>

                    <div class="list-group" *ngIf="newBenne.isGroupeArticle" style="margin-bottom: 15px">
                      <li class="list-group-item container" id="autofocus" style="height: auto; padding: 5px 2px;"
                        *ngFor="let item of newBenne.listArticle; let i = index;" tabindex="{{i}}">
                        <div class="col-sm-10" style="padding: 0px 4px 0;">
                          <div>
                            {{societe.qtePrevisionnelle ? item.qte || '' : ''}} {{item.art ?
                            (item.art.libelleObjetEntite || item.art.libelle) :
                            ''}}
                          </div>
                          <div>
                            {{item.exutoire ? (item.exutoire.libelleObjetEntite ||
                            item.exutoire.nom) : ''}}
                          </div>
                        </div>
                        <div class="col-sm-2 text-center" style="padding: 0;">
                          <button class="btn-detail" style="margin: 0px 1px;"
                            (click)="selactedArticle = item; showArticleGrp();">
                            <i class="fa fa-pencil"></i>
                          </button>
                          <button class="btn-detail" style="margin: 0px 1px;"
                            (click)="deleteListArticles(newBenne.listArticle, item)">
                            <i class="fa fa-trash"></i>
                          </button>
                        </div>
                      </li>
                    </div>

                    <div class="form-group" *ngIf="societe.axeAnalytiqueLigneBon && !newBenne.isGroupeArticle">
                      <label *ngIf="newBenne.axeAnalytiqueLigneArt || newBenne.axeAnalytiqueLigneArtfocus"
                        style="position: absolute">
                        Axe ana. Art </label>
                      <input type="text" class="form-control info" id="axeAnalytiqueLigneArt" placeholder="Axe ana. Art"
                        autofocus [(ngModel)]="newBenne.axeAnalytiqueLigneArt"
                        (focus)="newBenne.axeAnalytiqueLigneArtfocus = true;"
                        [ngClass]="{'noValue': !newBenne.axeAnalytiqueLigneArt && !newBenne.axeAnalytiqueLigneArtfocus}"
                        (blur)="newBenne.axeAnalytiqueLignefocus = false;" autocomplete="off">
                    </div>
                    <ng-template [ngIf]="societe.gestionBenneClient">
                      <div class="form-group" id="btnAppartCli">
                        <mat-checkbox [color]="'primary'" [(ngModel)]="newBenne.benneClient"
                          (ngModelChange)="newBenne.mailContenant = ''">
                          <label>Appartient au client </label>
                        </mat-checkbox>
                      </div>
                    </ng-template>
                    <div class="form-group" *ngIf="societe.mailBenneChantiers">
                      <label *ngIf="newBenne.mailContenant || newprest.mailContenantfocus" style="position: absolute">
                        Mail </label>
                      <input type="text" class="form-control info" id="mailContenant" placeholder="Mail" autofocus
                        [(ngModel)]="newBenne.mailContenant" (keyup.enter)="setValue('test', 'cont')"
                        [ngClass]="{'noValue': !newBenne.mailContenant && !newprest.mailContenantfocus}"
                        (focus)="newprest.mailContenantfocus = true;" (blur)="newprest.mailContenantfocus = false;"
                        [ngStyle]="{'padding':  (newBenne.mailContenant  || newBenne.mailContenantfocus) ? 'padding: 16px 10px 0 10px' : '0 10px'}"
                        [disabled]="!newBenne.benneClient" autocomplete="off">
                    </div>
                    <div class="form-group col-sm-6" style="padding: 0; margin-top: 15px;">
                      <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
                        [(ngModel)]="newBenne.isLocation" [disabled]="!isDroitModifLocation">
                      <span *ngIf="isDroitModifLocation" id="btn-location"
                        (click)="newBenne.isLocation = !newBenne.isLocation" style="cursor: pointer;">
                        Location </span>
                      <span *ngIf="!isDroitModifLocation" style="cursor: pointer;">
                        Location </span>
                    </div>
                    <div class="form-group col-sm-6">
                      <app-input-date [container]="true" [closeDatepickerOnSelect]="true" [class]="'col-sm-12 date'"
                        [id]="'date2'" [model]="newBenne.dateDebutLoc" (changefct)="newBenne.dateDebutLoc = $event;"
                        [placeholder]="'Date debut'" [activeNavigate]="true"
                        (keyenterfct)="changeDatePlanning('dateDebutLoc');common.changeDate($event, newBenne.dateDebutLoc); setValue(newBenne, 'newBenne')"
                        (selectfct)="selectDate($event, '#date2')"
                        [disable]="!newBenne.isLocation || !isDroitModifLocation" [position]="'bottom-right'"
                        [showDatepicker]="true"></app-input-date>
                    </div>
                    <div class="form-group col-sm-12" *ngIf="newBenne.isLocation" style="padding: 0; margin: 0;"
                      [ngStyle]="{'margin-top': objectFocus.typeContenant && !newBenne.isGroupeArticle ? '10px' : (objectFocus.article ? '67px' :'0px')}">
                      <label class="text" style="  margin: 0;padding-left: 0px;" (click)="showFacturation()">
                        <span class='text-underline uppercase'> Facturation </span></label>
                    </div>
                  </div>

                  <label class="text col-sm-12 p-0" style=" margin-top: 15px;padding-left: 0px;"
                    [ngStyle]="{'margin-top': (objectFocus.article && !newBenne.isLocation ? '75px' :'15px')}"
                    (click)="newprest.newContenant = !newprest.newContenant;  newprest.IsAfficheNewContenant = !newprest.IsAfficheNewContenant ; newBenne = {};">
                    <span class='text-underline uppercase' *ngIf='!addContenant'> choix du contenant </span></label>
                  <div class="uppercase col-sm-12 p-0" style="margin: 10px 0px 0px;">
                    <button class="btn-ok" id="oknewBenne"
                      (click)="setValue(newBenne, 'newBenne',false,false,true);verifyIfvalidContenant();">
                      OK
                    </button>
                    <label>Appuyez sur
                      <b>Entrée</b> pour valider.</label>
                  </div>
                </div>
                <div *ngIf="addArticle" style="height: calc(100% - 45px); overflow-y: auto;">
                  <div class="col-sm-12" style="padding: 0;">
                    <div class="form-group">
                      <app-autocomplete [placeholder]="'Article'" id="articlegrp"
                        (searchfunction)="objectFocus.articlegrp = true;searchArticle($event, newBenne.listArticle)"
                        (selectfunction)="selactedArticle.art = $event;   actualiseArt(selactedArticle.art, selactedArticle);"
                        [results]="listArticle" [label]="'Article'" [container]="true"
                        [defaultselected]="selactedArticle.art"
                        (keyenterfunction)="selactedArticle.art && selactedArticle.art.id ? common.focusElement('.exugrp') : false"
                        [defaultsearch]="selactedArticle.art ? (selactedArticle.art.libelleObjetEntite || selactedArticle.art.libelle) : ''">
                      </app-autocomplete>
                    </div>
                    <div class="form-group">
                      <app-autocomplete [placeholder]="'Exutoire'" id="exugrp"
                        (searchfunction)="objectFocus.exutoiregrp = true;searchExutoire($event)"
                        (selectfunction)="selactedArticle.exutoire = $event;" [results]="listExutoire"
                        [label]="'Exutoire'" [defaultselected]="selactedArticle.exutoire"
                        (keyenterfunction)="selactedArticle.art && selactedArticle.art.id ? showArticleGrp() : common.focusElement('.articlegrp')"
                        [defaultsearch]="selactedArticle.exutoire ? (selactedArticle.exutoire.libelleObjetEntite || selactedArticle.exutoire.nom) : ''">
                      </app-autocomplete>
                    </div>
                    <div class="form-group" *ngIf="societe.qtePrevisionnelle">
                      <label *ngIf="selactedArticle.qte || selactedArticle.qtefocus" style="position: absolute">
                        Qté Prev </label>
                      <input type="number" step="1" class="form-control info" id="qte" placeholder="Qté Prev" autofocus
                        [(ngModel)]="selactedArticle.qte" (focus)="selactedArticle.qtefocus = true;"
                        (blur)="selactedArticle.qtefocus = false;"
                        [ngClass]="{'noValue': !selactedArticle.qte && !selactedArticle.qtefocus}"
                        (keyup.enter)="selactedArticle.art && selactedArticle.art.id ? showArticleGrp() : common.focusElement('.articlegrp')"
                        autocomplete="off">
                    </div>
                    <div class="form-group" *ngIf="societe.axeAnalytiqueLigneBon">
                      <label *ngIf="selactedArticle.axeAnalytiqueLigneArt || selactedArticle.axeAnalytiqueLigneArtfocus"
                        style="position: absolute">
                        Axe ana. Art </label>
                      <input type="text" class="form-control info"
                        [ngClass]="{'noValue': !selactedArticle.axeAnalytiqueLigneArt && !selactedArticle.axeAnalytiqueLigneArtfocus}"
                        id="axeAnalytiqueLigneArt" placeholder="Axe ana. Art" autofocus
                        [(ngModel)]="selactedArticle.axeAnalytiqueLigneArt"
                        (focus)="selactedArticle.axeAnalytiqueLigneArtfocus = true;"
                        [ngClass]="{'noValue': !selactedArticle.axeAnalytiqueLigneArt && !selactedArticle.axeAnalytiqueLigneArtfocus}"
                        (keyup.enter)="selactedArticle.art && selactedArticle.art.id ? showArticleGrp() : common.focusElement('.articlegrp')"
                        (blur)="selactedArticle.axeAnalytiqueLignefocus = false;" autocomplete="off">
                    </div>
                  </div>


                  <div class="uppercase col-sm-12" style="margin: 10px 0px;padding: 0px;"
                    [ngStyle]="{'margin-top': objectFocus.articlegrp ? '120px' : (objectFocus.exutoiregrp ? '180px' : '10px') }">
                    <button class="btn-ok" id="okAddArticle"
                      (click)="selactedArticle.art && selactedArticle.art.id ? showArticleGrp() : common.focusElement('.articlegrp')">
                      OK
                    </button>
                    <label>Appuyez sur
                      <b>Entrée</b> pour valider.</label>
                  </div>
                </div>
              </div>
              <div *ngIf="(isGroupe || modifierGroupe )&& !newprest.tournee" style="height: 100%">
                <div style="margin-bottom: 10px">
                  <span class="step-title" *ngIf="!deposerContenant"> Contenants du groupe </span>
                  <span class="step-title" *ngIf="deposerContenant"> Ajouter un contenant </span>
                </div>
                <mat-checkbox [color]="'primary'" [(ngModel)]="isGroupe" (ngModelChange)="showGroupeContenant()"
                  *ngIf="isCreateWithBtn && !modifierGroupe && !deposerContenant">
                  <label>Groupe contenant</label>
                </mat-checkbox>
                <div style="height:100%">
                  <ng-template [ngIf]="!deposerContenant">
                    <div class="col-sm-12 " [ngClass]="{'disabledbutton': disableModifGroupe || isDmdEcoGED}"
                      style="padding: 0;">
                      <app-autocomplete [placeholder]="'Choisir un contenant déjà crée'"
                        [id]="'ChoiceContent choixContenantBennes'" [isCombo]="true"
                        [encoursDechargement]="encoursDechargement" (searchfunction)="searchGroupeContenantChoix()"
                        [results]="listcontenantGroupe" [label]="''" (selectfunction)="addContenantToGroupe($event)"
                        [defaultselected]="false" [container]="true" [selectvalue]="true" [pastoogledebut]="true"
                        [deleteLibelle]="true" [showArrowDown]="true" [dropdownclass]="'maxZindex'"
                        [defaultsearch]="'Choisir un contenant déjà crée'">
                      </app-autocomplete>
                    </div>
                    <label class="text" id="btnAddConentGrp"
                      [ngClass]="{'disabledbutton': disableModifGroupe || isDmdEcoGED}"
                      style=" margin-top: 15px;padding-left: 0px;" *ngIf="!deposerContenant && !modifContenantGrp"
                      (click)="deposerContenant = !deposerContenant; addContenantDepot();">
                      <span class='text-underline uppercase'> ajouter un contenant </span></label>
                  </ng-template>
                  <ng-template [ngIf]="!deposerContenant">
                    <div style="margin-bottom: 15px">
                      <span class="step-title"> Contenant du groupes
                      </span>
                    </div>

                    <div class="list-group" style="overflow-y: hidden ! important;  overflow-x: hidden ! important; height: calc(100% - 240px);
                    border-radius: 5px;
                    opacity: 1;">
                      <cdk-virtual-scroll-viewport [itemSize]="120" style="width: 100%;">
                        <ng-container
                          *cdkVirtualFor="let item of listBenneSelected;trackBy:common.trackById; let i = index;">
                          <li class="list-group-item  clearfix" (keyup)="changeFocusCont($event, i)"
                            [ngClass]="{'disabledbutton': isDmdEcoGED}" style="padding: 5px 2px;"
                            [ngStyle]="{'height': item.art && item.art.amiante ? '165px' : '120px'}" tabindex="{{i}}"
                            id="autofocus0{{i}}">
                            <!-- [ngClass]="{'contenantGroupe': item.isChecked}" -->
                            <!-- [ngClass]="{'contenantGroupe': selectedContenant(item)}" -->

                            <div class="col-sm-12 p-0">
                              <div class="col-sm-12 p-0" style="margin-bottom: 5px;">
                                <div class="col-sm-8 benne" style="max-height: 75px;">

                                  <div style="width: 40px; position: relative; padding-right: 0px;">

                                    <div *ngIf="item.id && item.id < 0" class=""
                                      [ngClass]="{'disabledbutton': item && item.typeContenant && item.typeContenant.isUnitaire}">
                                      <label *ngIf="item.qteContenant || newprest.qteContenantfocus"
                                        style="position: absolute;font-size: 11px;text-align: left;color: rgba(55, 97, 148, 0.6);padding: 4px 8px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                                        Qté </label>
                                      <input type="number" step="1" class="form-control info" id="qteContenant"
                                        placeholder="Qté" autofocus [(ngModel)]="item.qteContenant"
                                        (focus)="newprest.qteContenantfocus = true;" style="height: 47px;"
                                        [ngClass]="{'noValue': !item.qteContenant && !newprest.qteContenantfocus}"
                                        (blur)="newprest.qteContenantfocus = false;" autocomplete="off">
                                    </div>

                                    <div *ngIf="item.id && item.id > 0" class=""
                                      [ngClass]="{'disabledbutton': item && item.typeContenant && item.typeContenant.isUnitaire}"
                                      (click)="listQteComboGroup(item)">
                                      <app-autocomplete [placeholder]="'Qté'" [id]="'listQteId'"
                                        (searchfunction)="listQteComboGroup(item)" [showonclick]="true"
                                        (selectfunction)="item.qteContenant = $event.libelleObjetEntite;"
                                        [isCombo]="true" [results]="item.listQte" [label]="'Qté'"
                                        [defaultselected]="qteSelected" [container]="true" [selectvalue]="true"
                                        [disablefocus]="true" [defaultsearch]="item.qteContenant || ''">
                                      </app-autocomplete>
                                    </div>
                                  </div>
                                  <div class="text-left  " style="padding: 0px 5px; width: calc(100% - 40px);"
                                    [ngStyle]="{'width': 'calc(100% - 40px)' }">
                                    <div *ngIf="!item.isGroupeBenne" class="col-sm-12 ellipsis" style="padding: 0px;">
                                      <div class="col-sm-12" style="padding: 0;margin-bottom: 5px;" *ngIf="isMouvPraxy">
                                        <app-autocomplete
                                          (selectfunction)="item.typeContenant = $event; common.focusElement('.articleCont')"
                                          [results]="typeContenant" [highlight]="true" [showonclick]="true"
                                          (searchfunction)="searchTypecontenantByLibelle($event)" [container]="true"
                                          [label]="'Type contenant'" id="typeContDep" [placeholder]="'Type contenant'"
                                          (keyenterfunction)="common.focusElement('.articleCont')"
                                          [defaultselected]="item.typeContenant" [selectvalue]="true"
                                          [disablefocus]="true"
                                          [defaultsearch]="item.typeContenant ? item.typeContenant.libelleObjetEntite : ''">
                                        </app-autocomplete>
                                      </div>

                                      <div class="col-sm-12 ellipsis"
                                        style="padding: 0;white-space: nowrap; text-overflow: ellipsis; overflow: hidden;"
                                        *ngIf="!isMouvPraxy">
                                        <span *ngIf="item.typeContenant && item.typeContenant.famille">
                                          {{item.typeContenant.famille.libelle}}
                                        </span>
                                        <span *ngIf="item.typeContenant && item.typeContenant.cubage">
                                          {{item.typeContenant.cubage.cubage || '0'}}</span>
                                        <span *ngIf="item.typeContenant && item.typeContenant.uniteCont">
                                          {{item.typeContenant.uniteCont.libelle}} </span>
                                      </div>

                                      <div *ngIf="item.isGroupeArticle" class="col-sm-12 ellipsis"
                                        style="padding: 0px;">
                                        Grp Art
                                      </div>
                                      <div class="col-sm-12 ellipsis" *ngIf="item.art && !item.isGroupeArticle"
                                        style="padding: 0px; width: 100%; overflow: hidden;"
                                        [ngStyle]="{'white-space': 'nowrap'}">
                                        {{item.art.code}} {{item.isGroupeArticle? '': '/' }} {{item.art.libelle ||
                                        item.art.libelleObjetEntite}}
                                      </div>
                                      <div class="col-sm-12 ellipsis" style="padding: 0px;" *ngIf="item.isLocation">
                                        <span> Location </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <!-- <app-contenant [item]="item" [addClassGroupCreate]="true" [common]="common"
                                  [isEditableTypeContenant]="isMouvPraxy" [showAllArticle]="true" [champQte]="true"
                                  [showNotif]="false">
                                </app-contenant> -->
                                <div class="col-sm-3 p-0" style="width: 22%;">
                                  <app-autocomplete *ngIf="item.operationBenne && item.operationBenne.id === 0"
                                    (focusfunction)="objectFocus.typeOperation = true;"
                                    (selectfunction)="item.operationBenne = $event;actualiseOperation(item);"
                                    [container]="true" [results]="dataDepot" [highlight]="true" [isCombo]="true"
                                    [label]="'Opération'" id="typeOperation" [placeholder]="'Opération'"
                                    [defaultselected]="item.operationBenne" [disablefocus]="true"
                                    [defaultsearch]="item.operationBenne ? (item.operationBenne.libelleObjetEntite ) : ''">
                                  </app-autocomplete>

                                  <app-autocomplete *ngIf="item.operationBenne && item.operationBenne.id === 1"
                                    (focusfunction)="objectFocus.typeOperation = true;" [container]="true"
                                    (selectfunction)="item.operationBenne = $event;actualiseOperation(item);"
                                    [results]="dataRetrait" [highlight]="true" [isCombo]="true" [label]="'Opération'"
                                    id="typeOperation" [placeholder]="'Opération'"
                                    [defaultselected]="item.operationBenne" [disablefocus]="true"
                                    [defaultsearch]="item.operationBenne ? (item.operationBenne.libelleObjetEntite ) : ''">
                                  </app-autocomplete>

                                  <app-autocomplete *ngIf="item.operationBenne && item.operationBenne.id === 2"
                                    (focusfunction)="objectFocus.typeOperation = true;" [container]="true"
                                    (selectfunction)="item.operationBenne = $event;actualiseOperation(item);"
                                    [results]="dataRotation" [disablefocus]="true" [highlight]="true" [isCombo]="true"
                                    [label]="'Opération'" id="typeOperation" [placeholder]="'Opération'"
                                    [defaultselected]="item.operationBenne"
                                    [defaultsearch]="item.operationBenne ? (item.operationBenne.libelleObjetEntite ) : ''">
                                  </app-autocomplete>

                                  <app-autocomplete
                                    *ngIf="item.operationBenne && item.operationBenne.id === 6 && !societe.operationBenneSupp"
                                    (focusfunction)="objectFocus.typeOperation = true;" [disablefocus]="true"
                                    (selectfunction)="item.operationBenne = $event;actualiseOperation(item);"
                                    [container]="true" [results]="dataAutre" [highlight]="true" [isCombo]="true"
                                    [label]="'Opération'" id="typeOperation" [placeholder]="'Opération'"
                                    [defaultselected]="item.operationBenne"
                                    [defaultsearch]="item.operationBenne ? (item.operationBenne.libelleObjetEntite ) : ''">
                                  </app-autocomplete>

                                  <app-autocomplete *ngIf="societe.operationBenneSupp  && item.operationBenne && item.operationBenne.id !== 0 && item.operationBenne.id !== 1
                                      && item.operationBenne.id !== 2 && item.isBenneEnPlace "
                                    (focusfunction)="objectFocus.typeOperation = true;"
                                    (selectfunction)="item.operationBenne = $event;actualiseOperation(item);"
                                    [container]="true" [disablefocus]="true" [results]="dataOppSuppBennePlace"
                                    [highlight]="true" [isCombo]="true" [label]="'Opération'" id="typeOperation"
                                    [placeholder]="'Opération'" [defaultselected]="item.operationBenne"
                                    [defaultsearch]="item.operationBenne ? (item.operationBenne.libelleObjetEntite ) : ''">
                                  </app-autocomplete>

                                  <app-autocomplete *ngIf="societe.operationBenneSupp  && item.operationBenne && item.operationBenne.id !== 0 && item.operationBenne.id !== 1
                                    && item.operationBenne.id !== 2 && item.isBenneNonEnPlace"
                                    (focusfunction)="objectFocus.typeOperation = true;"
                                    (selectfunction)="item.operationBenne = $event;actualiseOperation(item);"
                                    [container]="true" [results]="dataOppSupp" [highlight]="true" [isCombo]="true"
                                    [label]="'Opération'" id="typeOperation" [disablefocus]="true"
                                    [placeholder]="'Opération'" [defaultselected]="item.operationBenne"
                                    [defaultsearch]="item.operationBenne ? (item.operationBenne.libelleObjetEntite ) : ''">
                                  </app-autocomplete>

                                  <app-autocomplete
                                    *ngIf="!societe.operationBenneSupp  && item.operationBenne && item.operationBenne.id !== 0 && item.operationBenne.id !== 1
                                      && item.operationBenne.id !== 2 && item.operationBenne.id !== 6 && item.isBenneEnPlace "
                                    (focusfunction)="objectFocus.typeOperation = true;"
                                    (selectfunction)="item.operationBenne = $event;actualiseOperation(item);"
                                    [container]="true" [results]="dataOppSuppBennePlace" [highlight]="true"
                                    [isCombo]="true" [label]="'Opération'" id="typeOperation" [disablefocus]="true"
                                    [placeholder]="'Opération'" [defaultselected]="defaultSelected"
                                    [defaultsearch]="item.operationBenne ? (item.operationBenne.libelleObjetEntite ) : ''">
                                  </app-autocomplete>
                                  <app-autocomplete
                                    *ngIf="!societe.operationBenneSupp  && item.operationBenne && item.operationBenne.id !== 0 && item.operationBenne.id !== 1
                                      && item.operationBenne.id !== 2 && item.operationBenne.id !== 6 && item.isBenneNonEnPlace"
                                    (focusfunction)="objectFocus.typeOperation = true;"
                                    (selectfunction)="item.operationBenne = $event;actualiseOperation(item);"
                                    [container]="true" [results]="dataOppSupp" [highlight]="true" [isCombo]="true"
                                    [label]="'Opération'" id="typeOperation" [disablefocus]="true"
                                    [placeholder]="'Opération'" [defaultselected]="defaultSelected"
                                    [defaultsearch]="item.operationBenne ? (item.operationBenne.libelleObjetEntite ) : ''">
                                  </app-autocomplete>

                                </div>
                                <div class="col-sm-1 text-center  p-0" style="width: 10%;  max-width: 10%;">
                                  <div class="col-sm-12 p-0">
                                    <button class="btn-detail"
                                      (click)="item.isChecked = false;selectContenantForGroup(item)">
                                      <i class="fa fa-trash"></i>
                                    </button>
                                  </div>


                                  <div class="col-sm-12 p-0" style="margin-top: 2px;">
                                    <button class="btn-detail" (click)="modifContenantForGroup(item)">
                                      <i class="fa fa-pencil"></i>
                                    </button>
                                  </div>

                                  <!-- <mat-checkbox class="example-margin" color="primary" [(ngModel)]="item.isChecked"
                                    (ngModelChange)="selectContenantForGroup(item)">
                                  </mat-checkbox> -->
                                </div>
                              </div>

                              <div class="col-sm-12 p-0" style="position: relative;">
                                <label style="position: absolute;
                                margin: 0; z-index: 5;" *ngIf="item.numBSDDfocus || item.numBSDDManuel"> N°
                                  de BSD manuel
                                </label>
                                <input type="text" style="position: relative;
                          opacity: 1;" class="form-control info" placeholder="N° de BSD manuel"
                                  [(ngModel)]="item.numBSDDManuel" id="btnBsdManuel{{i}}"
                                  [ngClass]="{'noValue': !item.numBSDDfocus && !item.numBSDDManuel}"
                                  (keyup.enter)="setValue(true, 'divers')" (focus)="item.numBSDDfocus = true;"
                                  (blur)="item.numBSDDfocus = false;" autocomplete="off">
                              </div>
                              <div class=" col-sm-12 p-0" *ngIf="item.art && item.art.amiante"
                                style="position: relative;margin-top: 5px;">
                                <label style="position: absolute;
                            margin: 0;z-index: 5;" *ngIf="item.numScellefocus || item.numScelle">Num Scellé
                                </label>
                                <input type="text" style="position: relative;
                            opacity: 1;" class="form-control info" placeholder="Num Scellé"
                                  [(ngModel)]="item.numScelle" (keyup.enter)="setValue(true, 'divers')"
                                  (focus)="item.numScellefocus = true;" (blur)="item.numScellefocus = false;"
                                  [ngStyle]="{'padding': !item.numScellefocus && !item.numScelle ? '8px 10px 0 10px' : '16px 10px 0px'}"
                                  autocomplete="off">
                              </div>
                            </div>
                          </li>
                        </ng-container>
                      </cdk-virtual-scroll-viewport>
                    </div>

                  </ng-template>

                  <div class="list-group" style="background-color: transparent;height: 245px;" *ngIf="deposerContenant">
                    <div class="form-group">
                      <app-autocomplete
                        (selectfunction)="contenantDepot.operationBenne = $event; actualiseOperation(contenantDepot); common.focusElement('.typeContDep')"
                        [results]="dataDepot" [highlight]="true" [isCombo]="true" [label]="'Type de l\'opération'"
                        id="operationBac" [placeholder]="'Type de l\'opération'" [selectvalue]="true"
                        [disablefocus]="true" [defaultselected]="contenantDepot.operationBenne"
                        [defaultsearch]="contenantDepot.operationBenne ? contenantDepot.operationBenne.libelleObjetEntite : ''">
                      </app-autocomplete>
                    </div>
                    <div class="form-group">
                      <app-autocomplete
                        (selectfunction)="contenantDepot.typeContenant = $event; common.focusElement('.articleCont')"
                        [results]="typeContenant" [highlight]="true" [showonclick]="true"
                        (searchfunction)="objectFocus.typeContgrp = true;searchTypecontenantByLibelle($event)"
                        [label]="'Type contenant'" id="typeContDep" [placeholder]="'Type contenant'"
                        (keyenterfunction)="common.focusElement('.articleCont')" [container]="true"
                        [defaultselected]="contenantDepot.typeContenant" [selectvalue]="true" [disablefocus]="true"
                        [defaultsearch]="contenantDepot.typeContenant ? contenantDepot.typeContenant.libelleObjetEntite : ''">
                      </app-autocomplete>
                    </div>
                    <div class="form-group">
                      <app-autocomplete [placeholder]="'Article'" id="articleCont"
                        (searchfunction)="objectFocus.artgrp = true;searchArticleDepot($event);"
                        (selectfunction)="contenantDepot.art = $event; common.focusElement('#qteBac'); detailArt(contenantDepot.art, contenantDepot)"
                        [results]="dataArticleDepot" [label]="'Article'" [container]="true" [selectvalue]="true"
                        [disablefocus]="true" (keyenterfunction)="common.focusElement('#qteBac')"
                        [defaultselected]="contenantDepot.art"
                        [defaultsearch]="contenantDepot.art ? (contenantDepot.art.libelleObjetEntite || contenantDepot.art.libelle) : ''">
                      </app-autocomplete>
                    </div>

                    <div class="form-group"
                      [ngClass]="{'disabledbutton': contenantDepot.typeContenant && contenantDepot.typeContenant.isUnitaire}">
                      <label *ngIf="contenantDepot.qteContenant || contenantDepot.qtefocus" style="position: absolute">
                        Quantité </label>
                      <input type="number" step="1" class="form-control info" id="qteBac" placeholder="Quantité"
                        autofocus [(ngModel)]="contenantDepot.qteContenant" (keyup.enter)="setGroupeBenne();"
                        (focus)="contenantDepot.qtefocus = true;" (blur)="contenantDepot.qtefocus = false;"
                        [ngClass]="{'noValue': !contenantDepot.qteContenant && !contenantDepot.qtefocus}"
                        autocomplete="off">
                    </div>
                  </div>
                  <!-- <button class="pull-right deposerCont" *ngIf="!deposerContenant"
                    (click)="deposerContenant = !deposerContenant; addContenantDepot();"><label class="text">
                      <span class='text-underline uppercase'> Ajouter un contenant </span></label>
                  </button> -->

                  <div class="uppercase col-sm-12" style="margin: 10px 0px; padding: 0px;"
                    [ngStyle]="{'margin-top': objectFocus.typeContgrp ? '55px' : (objectFocus.artgrp ? '120px' : '10px') }">
                    <button class="btn-ok" id="okSetGroupeBenne" (click)="setGroupeBenne();">
                      OK
                    </button>
                    <label>Appuyez sur
                      <b>Entrée</b> pour valider.</label>
                  </div>
                </div>
              </div>
              <div *ngIf="newprest.tournee" style="    height: 100%;">
                <div style="margin-bottom: 15px">
                  <span class="step-title"> Contenants de la tournée </span>
                  <span class="step-title"> </span>
                </div>
                <div style="height:100%">
                  <div class="col-sm-12 text-right" style="padding: 5px 0px">
                    <button class="btn-detail" (click)="toogleSlideTournee()">
                      <i class="fa fa-plus"></i>
                    </button>
                    <span (click)="toogleSlideTournee()" class="cursor"> Ajouter un contenant
                    </span>
                  </div>
                  <div class="list-group col-sm-12" *ngIf="detailTournee.listeContenants"
                    style="overflow:auto; padding: 0; max-height: calc(100% - 120px);" dragula="DRAGULA_EVENTS"
                    [(dragulaModel)]="detailTournee.listeContenants">
                    <li class="list-group-item container" id="autofocus" (click)="selectContenantForGroup(item)"
                      (keyup)="changeFocusCont($event, i)" style="height: auto; padding: 5px 2px;"
                      *ngFor="let item of detailTournee.listeContenants; let i = index;" tabindex="{{i}}"
                      [attr.id]="item.id">
                      <div class="col-sm-1 numero"> {{ i + 1}} </div>
                      <div class="col-sm-10" style="padding: 0;">
                        <app-contenant [item]="item" [isListetourne]="true" [common]="common" [showNotif]="true"
                          [showAllArticle]="true" [showcht]="true">
                        </app-contenant>
                      </div>
                      <div class="col-sm-1" style="padding: 10px 2px;">
                        <button class="btn-detail pull-right" (click)="deleteLigne(item)">
                          <i class="fa fa-trash"></i>
                        </button>
                      </div>


                    </li>
                    <li class="list-group-item container" id="autofocus" tabindex="0"
                      *ngIf="!detailTournee.listeContenants || (detailTournee.listeContenants && !detailTournee.listeContenants.length)"
                      style="height: auto;">
                      Pas de contenant
                    </li>
                  </div>

                  <div class="uppercase col-sm-12" style="margin: 10px 0px; padding: 0px;">
                    <button class="btn-ok" id="okSetTourne" (click)="setValue(detailTournee, 'testTourne')">
                      OK
                    </button>
                    <label>Appuyez sur
                      <b>Entrée</b> pour valider.</label>
                  </div>
                </div>
              </div>

              <!-- ajout dans etape 3 -->
              <div class="etape3-phase2"
                *ngIf="!isGroupe && !modifierGroupe && !newprest.IsAfficheNewContenant && !addArticle" [ngStyle]="{'height': !newprest.IsAfficheNewContenant && !addArticle && !isEditContenant ? 'calc(100% - 126px)' : '100%',
              'margin-top': !newprest.IsAfficheNewContenant && !addArticle && !isEditContenant ? '5px' :'-15px'}">
                <div style="margin-bottom: 15px">
                  <span class="step-title" *ngIf="!isEditContenant && !addArticle"> Vérifier le contenant
                  </span>
                  <span class="step-title" *ngIf="isEditContenant && !addArticle"> Modification du
                    contenant </span>
                  <span class="step-title" *ngIf="addArticle"> Groupe d'article </span>
                </div>
                <div class="list-group" *ngIf="!isEditContenant && !addArticle">
                  <li class="list-group-item container" id="autofocus2" tabindex="0" *ngIf="selectedChantier"
                    (keyup.enter)="setValue('test', 'cont')" (click)="setValue('test', 'cont')"
                    style="height: auto; min-height: 47px;">
                    <app-contenant *ngIf="newprest.contenant" [item]="newprest.contenant" [showAllArticle]="true"
                      [common]="common">
                    </app-contenant>
                    <app-contenant *ngIf="newprest.newBenne" [item]="newprest.newBenne" [showAllArticle]="true"
                      [common]="common"></app-contenant>
                  </li>
                </div>
                <div class="col-sm-12" *ngIf="isEditContenant && !addArticle"
                  style="height: auto;max-height: calc(100% - 115px); overflow-y: auto;padding: 0;">
                  <div *ngIf="newprest.contenant">
                    <div class="form-group">
                      <app-autocomplete
                        (selectfunction)="newprest.contenant.typeContenant = $event;   common.focusElement('.articleCont');  actualiseCont(newprest.contenant)"
                        [results]="typeContenant" [highlight]="true" [showonclick]="true"
                        (searchfunction)="objectFocus.typeContenant = true;searchTypecontenantByLibelle($event)"
                        [label]="'Type contenant'" id="typecontenant" [placeholder]="'Type contenant'"
                        (keyenterfunction)="common.focusElement('.articleCont')" [container]="true"
                        [defaultselected]="newprest.contenant.typeContenant"
                        [defaultsearch]="newprest.contenant.typeContenant ? newprest.contenant.typeContenant.libelleObjetEntite : ''">
                      </app-autocomplete>
                    </div>
                    <div class="form-group" *ngIf="!newprest.contenant.isGroupeArticle">
                      <app-autocomplete [placeholder]="'Article'" id="articleCont"
                        (searchfunction)="objectFocus.article = true;searchArticle($event)"
                        (selectfunction)="newprest.contenant.art = $event;  common.focusElement('.articleCont');   actualiseArt(newprest.contenant.art, newprest.contenant);"
                        [results]="listArticle" [label]="'Article'" [container]="true"
                        (keyenterfunction)="newprest.contenant.art ?  setValue('test', 'cont')  : false"
                        [defaultselected]="newprest.contenant.art"
                        [defaultsearch]="newprest.contenant.art ? newprest.contenant.art.libelleObjetEntite : ''">
                      </app-autocomplete>
                    </div>
                    <div class="form-group" *ngIf="societe.qtePrevisionnelle && !newprest.contenant.isGroupeArticle">
                      <label *ngIf="newprest.contenant.qte || newprest.qtefocus" style="position: absolute">
                        Qté Prev </label>
                      <input type="number" step="1" class="form-control info" id="qte" placeholder="Qté Prev" autofocus
                        [(ngModel)]="newprest.contenant.qte" (focus)="newprest.qtefocus = true;"
                        [ngClass]="{'noValue': !newprest.contenant.qte && !newprest.qtefocus}"
                        (blur)="newprest.qtefocus = false;" autocomplete="off">
                    </div>
                    <ng-template [ngIf]="operationBenneEnPlaceFalse">
                      <div class="form-group"
                        *ngIf="newprest.contenant && newprest.contenant.typeContenant && !newprest.contenant.typeContenant.isUnitaire">
                        <label *ngIf="newprest.contenant.qteContenant || newprest.qteContenantfocus"
                          style="position: absolute">
                          Quantité contenant </label>
                        <input type="number" step="1" class="form-control info" id="qteContenant"
                          placeholder="Quantité contenant" autofocus [(ngModel)]="newprest.contenant.qteContenant"
                          (keyup.enter)="setValue('test', 'cont')" (focus)="newprest.qteContenantfocus = true;"
                          [ngClass]="{'noValue': !newprest.contenant.qteContenant && !newprest.qteContenantfocus}"
                          (blur)="newprest.qteContenantfocus = false;" autocomplete="off">
                      </div>
                    </ng-template>

                    <ng-template [ngIf]="!operationBenneEnPlaceFalse">
                      <div class="form-group"
                        *ngIf="newprest.contenant && newprest.contenant.typeContenant && !newprest.contenant.typeContenant.isUnitaire">
                        <app-autocomplete [placeholder]="'Quantité contenant'" [id]="'listQteId'"
                          (selectfunction)="qteSelected = $event; setValueQte(); setValue('test', 'cont')"
                          [isCombo]="true" [results]="listQte" [label]="'Quantité contenant'"
                          [defaultselected]="qteSelected" [container]="true"
                          [defaultsearch]="qteSelected ? qteSelected.libelleObjetEntite : ''"
                          (keyenterfunction)="setValueQte(); setValue('test', 'cont')">
                        </app-autocomplete>
                      </div>
                    </ng-template>

                    <div class="form-group" *ngIf="societe.axeAnalytiqueLigneBon"
                      [ngClass]="{'disabledbutton': isMouvPraxy}">
                      <label *ngIf="newprest.contenant.axeAnalytiqueLigne || newprest.contenant.axeAnalytiqueLignefocus"
                        style="position: absolute">
                        Axe ana. Prest </label>
                      <input type="text" class="form-control info" id="axeAnalytiqueLigne" placeholder="Axe ana. Prest"
                        autofocus [(ngModel)]="newprest.contenant.axeAnalytiqueLigne"
                        (keyup.enter)="setValue('test', 'cont')"
                        [ngClass]="{'noValue': !newprest.contenant.axeAnalytiqueLigne && !newprest.contenant.axeAnalytiqueLignefocuss}"
                        (focus)="newprest.contenant.axeAnalytiqueLignefocus = true;"
                        (blur)="newprest.contenant.axeAnalytiqueLignefocus = false;" autocomplete="off">
                    </div>

                    <div class="form-group" *ngIf="societe.groupeArticleEcobennes"
                      [ngStyle]="{'margin-top': objectFocus.typeContenant && newprest.contenant.isGroupeArticle ? '190px' : '0px'}">
                      <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
                        [(ngModel)]="newprest.contenant.isGroupeArticle" (ngModelChange)="newprest.contenant.art = {}">
                      <span (click)="newprest.contenant.isGroupeArticle = !newprest.contenant.isGroupeArticle"
                        style="cursor: pointer;">
                        Groupe </span>
                      <label class="text pull-right" *ngIf="newprest.contenant.isGroupeArticle"
                        style=" margin: 0px;padding: 0px;" (click)="showArticleGrp(); addArticlesContenant()">
                        <span class='text-underline uppercase'> ajouter un article
                        </span></label>
                    </div>

                    <div class="list-group" *ngIf="newprest.contenant.isGroupeArticle" style="margin-bottom: 15px;">
                      <li class="list-group-item container" id="autofocus" style="height: auto; padding: 5px 2px;"
                        *ngFor="let item of newprest.contenant.listArticle; let i = index;" tabindex="{{i}}">

                        <div class="col-sm-10" style="padding: 0px 4px 0;">
                          <div>
                            {{societe.qtePrevisionnelle ? item.qte || '' : ''}}
                            {{item.art ? (item.art.code) :''}}/{{item.art ? (item.art.libelleObjetEntite
                            || item.art.libelle) :
                            ''}}
                          </div>
                          <div>
                            {{item.exutoire ? (item.exutoire.libelleObjetEntite ||
                            item.exutoire.nom) : ''}}
                          </div>
                        </div>
                        <div class="col-sm-2 text-center" style="padding: 0px">
                          <button class="btn-detail" style="margin: 0px 1px;"
                            (click)="selactedArticle = item; showArticleGrp();">
                            <i class="fa fa-pencil"></i>
                          </button>
                          <button class="btn-detail" style="margin: 0px 1px;"
                            (click)="deleteListArticles(newprest.contenant.listArticle, item)">
                            <i class="fa fa-trash"></i>
                          </button>
                        </div>

                      </li>
                    </div>

                    <div class="form-group" *ngIf="societe.axeAnalytiqueLigneBon && !newprest.contenant.isGroupeArticle"
                      [ngClass]="{'disabledbutton': isMouvPraxy}">
                      <label
                        *ngIf="newprest.contenant.axeAnalytiqueLigneArt || newprest.contenant.axeAnalytiqueLigneArtfocus"
                        style="position: absolute">
                        Axe ana. Art </label>
                      <input type="text" class="form-control info" id="axeAnalytiqueLigneArt" placeholder="Axe ana. Art"
                        autofocus [(ngModel)]="newprest.contenant.axeAnalytiqueLigneArt"
                        (focus)="newprest.contenant.axeAnalytiqueLigneArtfocus = true;"
                        [ngClass]="{'noValue': !newprest.contenant.axeAnalytiqueLigneArt && !newprest.contenant.axeAnalytiqueLigneArtfocus}"
                        (blur)="newprest.contenant.axeAnalytiqueLignefocus = false;" autocomplete="off">
                    </div>
                    <ng-template [ngIf]="societe.gestionBenneClient">
                      <div class="form-group" [ngClass]="{'disabledbutton': isMouvPraxy}">
                        <mat-checkbox [color]="'primary'" [(ngModel)]="newprest.contenant.benneClient"
                          (ngModelChange)="newprest.contenant.mailContenant = ''">
                          <label>Appartient au client </label>
                        </mat-checkbox>
                      </div>
                    </ng-template>
                    <div class="form-group" *ngIf="societe.mailBenneChantiers"
                      [ngClass]="{'disabledbutton': isMouvPraxy}">
                      <label *ngIf="newprest.contenant.mailContenant || newprest.mailContenantfocus"
                        style="position: absolute">
                        Mail </label>
                      <input type="text" class="form-control info" id="mailContenant" placeholder="Mail" autofocus
                        [(ngModel)]="newprest.contenant.mailContenant" (keyup.enter)="setValue('test', 'cont')"
                        (focus)="newprest.mailContenantfocus = true;" (blur)="newprest.mailContenantfocus = false;"
                        [ngStyle]="{'padding':  (newprest.contenant.mailContenant || newprest.mailContenantfocus) ? 'padding: 16px 10px 0 10px' : '0 10px'}"
                        [disabled]="!newprest.contenant.benneClient" autocomplete="off">
                    </div>
                    <div class="form-group col-sm-6" style="padding: 0; margin-top: 15px;"
                      [ngClass]="{'disabledbutton': isMouvPraxy}">
                      <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
                        [(ngModel)]="newprest.contenant.isLocation" [disabled]="isVidage">
                      <span (click)="newprest.contenant.isLocation = !newprest.contenant.isLocation"
                        style="cursor: pointer;">
                        Location </span>
                    </div>
                    <div class="form-group col-sm-6" [ngClass]="{'disabledbutton': isMouvPraxy}">
                      <app-input-date [container]="true" [closeDatepickerOnSelect]="true" [class]="'col-sm-12 date'"
                        [id]="'date'" [model]="newprest.contenant.dateDebutLoc"
                        (changefct)="newprest.contenant.dateDebutLoc = $event;" [placeholder]="'Date debut'"
                        (keyenterfct)="changeDatePlanning('dateDebutLoc', 'contenant');common.changeDate($event, newprest.contenant.dateDebutLoc); setValue('test', 'cont')"
                        (selectfct)="selectDate($event, '#date')" [activeNavigate]="true"
                        [disable]="!newprest.contenant.isLocation || isVidage" [position]="'bottom-right'"
                        [showDatepicker]="true"></app-input-date>
                    </div>
                    <div class="form-group col-sm-12" *ngIf="newprest.contenant.isLocation"
                      [ngClass]="{'disabledbutton': isMouvPraxy}"
                      [ngStyle]="{'margin-top': objectFocus.typeContenant && !newprest.contenant.isGroupeArticle ? '10px' : (objectFocus.article ? '67px' :'0px')}"
                      style="padding: 0; margin: 0 0 15px;">
                      <label class="text" style=" margin: 0;padding-left: 0px;" (click)="showFacturation()">
                        <span class='text-underline uppercase'> Facturation </span></label>
                    </div>
                    <div class="form-group items col-sm-12" id="conteneurLieu" style="padding: 0">
                      <app-autocomplete (searchfunction)="objectFocus.lieu = true; searchZone($event)"
                        [results]="resultZone" [highlight]="true"
                        [placeholder]="societe.clientCollectivite ? 'Circuit' : 'Lieu'"
                        [label]="societe.clientCollectivite ? 'Circuit' : 'Lieu'" [isCombo]="true" [disablefocus]="true"
                        [id]="'idLieu'" [notLoading]="true" [defaultselected]="newprest.lieu" [container]="true"
                        [defaultsearch]="newprest.lieu ? newprest.lieu.libelleObjetEntite || '' : ''"
                        (selectfunction)="objectFocus.lieu = false;newprest.lieu = $event;">
                      </app-autocomplete>
                    </div>
                  </div>
                  <div *ngIf="newprest.newBenne">
                    <div class="form-group">
                      <app-autocomplete
                        (selectfunction)="newprest.newBenne.typeContenant = $event;  common.focusElement('#autocomplete');   actualiseCont(newprest.newBenne);"
                        [results]="typeContenant" [highlight]="true" [showonclick]="true"
                        (searchfunction)="objectFocus.typeContenant = true;searchTypecontenantByLibelle($event)"
                        [label]="'Type contenant'" id="typecontenant" [placeholder]="'Type contenant'"
                        (keyenterfunction)="common.focusElement('.articleCont')" [container]="true"
                        [defaultselected]="newprest.newBenne.typeContenant"
                        [defaultsearch]="newprest.newBenne.typeContenant ? newprest.newBenne.typeContenant.libelleObjetEntite : ''">
                      </app-autocomplete>
                    </div>
                    <div class="form-group" *ngIf="!newprest.newBenne.isGroupeArticle">
                      <app-autocomplete [placeholder]="'Article'" id="articleCont"
                        (searchfunction)="objectFocus.article = true;searchArticle($event)"
                        (selectfunction)="newprest.newBenne.art = $event;  common.focusElement('.articleCont'); actualiseArt(selactedArticle.art, newprest.newBenne);"
                        [results]="listArticle" [label]="'Article'" [container]="true"
                        (keyenterfunction)="newprest.newBenne.art ? setValue('test', 'cont') : false"
                        [defaultselected]="newprest.newBenne.art"
                        [defaultsearch]="newprest.newBenne.art ? newprest.newBenne.art.libelleObjetEntite : ''">
                      </app-autocomplete>
                    </div>

                    <div class="form-group" *ngIf="societe.groupeArticleEcobennes"
                      [ngStyle]="{'margin-top': objectFocus.typeContenant && newprest.newBenne.isGroupeArticle ? '190px' : '0px'}">
                      <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
                        [(ngModel)]="newprest.newBenne.isGroupeArticle" (ngModelChange)="newprest.newBenne.art = {}">
                      <span (click)="newprest.newBenne.isGroupeArticle = !newprest.newBenne.isGroupeArticle"
                        style="cursor: pointer;">
                        Groupe </span>
                      <label class="text pull-right" *ngIf="newprest.newBenne.isGroupeArticle"
                        style=" margin: 0px;padding: 0px;" (click)="showArticleGrp(); addArticlesNewprest()">
                        <span class='text-underline uppercase'> ajouter un article
                        </span></label>
                    </div>

                    <div class="list-group" *ngIf="newprest.newBenne.isGroupeArticle" style="margin-bottom: 15px;">
                      <li class="list-group-item container" id="autofocus" style="height: auto; padding: 5px 2px;"
                        *ngFor="let item of newprest.newBenne.listArticle; let i = index;" tabindex="{{i}}">

                        <div class="col-sm-10" style="padding: 0px 4px 0;">
                          <div>
                            {{societe.qtePrevisionnelle ? item.qte || '' : ''}} {{item.art ?
                            (item.art.libelleObjetEntite
                            || item.art.libelle) :
                            ''}}
                          </div>
                          <div>
                            {{item.exutoire ? (item.exutoire.libelleObjetEntite ||
                            item.exutoire.nom) : ''}}
                          </div>
                        </div>
                        <div class="col-sm-2 text-center" style="padding: 0px;">
                          <button class="btn-detail" style="margin: 0px 1px;"
                            (click)="selactedArticle = item; showArticleGrp();">
                            <i class="fa fa-pencil"></i>
                          </button>
                          <button class="btn-detail" style="margin: 0px 1px;"
                            (click)="deleteListArticles(newprest.newBenne.listArticle, item)">
                            <i class="fa fa-trash"></i>
                          </button>
                        </div>
                      </li>
                    </div>

                    <ng-template [ngIf]="societe.gestionBenneClient">
                      <div class="form-group" [ngClass]="{'disabledbutton': isMouvPraxy}">
                        <mat-checkbox [color]="'primary'" [(ngModel)]="newprest.newBenne.benneClient"
                          (ngModelChange)="newprest.newBenne.mailContenant = ''">
                          <label>Appartient au client </label>
                        </mat-checkbox>
                      </div>
                    </ng-template>
                    <div class="form-group" *ngIf="societe.mailBenneChantiers"
                      [ngClass]="{'disabledbutton': isMouvPraxy}">
                      <label *ngIf="newprest.newBenne.mailContenant || newprest.mailContenantfocus"
                        style="position: absolute">
                        Mail </label>
                      <input type="text" class="form-control info" id="mailContenant" placeholder="Mail" autofocus
                        [(ngModel)]="newprest.newBenne.mailContenant" (keyup.enter)="setValue('test', 'cont')"
                        (focus)="newprest.mailContenantfocus = true;" (blur)="newprest.mailContenantfocus = false;"
                        [ngStyle]="{'padding':  (newprest.newBenne.mailContenant || newprest.mailContenantfocus) ? 'padding: 16px 10px 0 10px' : '0 10px'}"
                        [disabled]="!newprest.newBenne.benneClient" autocomplete="off">
                    </div>
                    <div class="form-group col-sm-6" style="padding: 0; margin-top: 15px;"
                      [ngClass]="{'disabledbutton': isMouvPraxy}">
                      <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
                        [(ngModel)]="newBenne.isLocation">
                      <span (click)="newprest.newBenne.isLocation = !newprest.newBenne.isLocation"
                        style="cursor: pointer;">
                        Location </span>
                    </div>
                    <div class="form-group col-sm-6" [ngClass]="{'disabledbutton': isMouvPraxy}">
                      <input type="text" class="col-sm-12 date" id="date" [ngModel]="newprest.newBenne.dateDebutLoc"
                        (ngModelChange)="newprest.newBenne.dateDebutLoc = $event;" placeholder="Date debut"
                        [placement]="'bottom-right'" (click)="newprest.newBenne.isLocation ? d.open() : d.close();"
                        ngbDatepicker NgbInputDatepicker [autoClose]="false" #d="ngbDatepicker"
                        (dateSelect)="selectDate($event, '#date')"
                        (focus)="newprest.newBenne.isLocation ? d.open(): d.close();"
                        (keydown)="setFocuscalendar($event)"
                        (keydown.enter)="d.close();changeDatePlanning('dateDebutLoc', 'newBenne');common.changeDate($event, newprest.newBenne.dateDebutLoc); setValue('test', 'cont')"
                        autocomplete="off" [disabled]="!newprest.newBenne.isLocation">
                    </div>
                    <div class="form-group col-sm-12" *ngIf="newprest.newBenne.isLocation"
                      [ngClass]="{'disabledbutton': isMouvPraxy}" style="padding: 0; margin: 0 0 15px;"
                      [ngStyle]="{'margin-top': objectFocus.typeContenant && !newprest.newBenne.isGroupeArticle ? '10px' : (objectFocus.article ? '67px' :'0px')}">
                      <label class="text" style=" margin: 0px;padding-left: 0px;" (click)="showFacturation()">
                        <span class='text-underline uppercase'> Facturation </span></label>
                    </div>
                    <div class="form-group items col-sm-12" id="conteneurLieu" style="padding: 0">
                      <app-autocomplete (searchfunction)="objectFocus.lieu = true; searchZone($event)"
                        [results]="resultZone" [highlight]="true"
                        [placeholder]="societe.clientCollectivite ? 'Circuit' : 'Lieu'"
                        [label]="societe.clientCollectivite ? 'Circuit' : 'Lieu'" [isCombo]="true" [disablefocus]="true"
                        [id]="'idLieu'" [notLoading]="true" [defaultselected]="newprest.lieu" [container]="true"
                        [defaultsearch]="newprest.lieu ? newprest.lieu.libelleObjetEntite || '' : ''"
                        (selectfunction)="objectFocus.lieu = false;newprest.lieu = $event;">
                      </app-autocomplete>
                    </div>
                  </div>
                </div>

                <div *ngIf="addArticle" style="height: calc(100% - 45px); overflow-y: auto;">
                  <div class="col-sm-12" style="padding: 0;">
                    <div class="form-group">
                      <app-autocomplete [placeholder]="'Article'" id="articlegrp"
                        (searchfunction)="objectFocus.articlegrp = true;searchArticle($event, newBenne.listArticle)"
                        (selectfunction)="selactedArticle.art = $event;  actualiseArt(selactedArticle.art, selactedArticle);"
                        [results]="listArticle" [label]="'Article'" [container]="true"
                        [defaultselected]="selactedArticle.art"
                        (keyenterfunction)="selactedArticle.art && selactedArticle.art.id ? common.focusElement('.exugrp') : false"
                        [defaultsearch]="selactedArticle.art ? (selactedArticle.art.libelleObjetEntite || selactedArticle.art.libelle) : ''">

                      </app-autocomplete>
                    </div>
                    <div class="form-group">
                      <app-autocomplete [placeholder]="'Exutoire'" id="exugrp"
                        (searchfunction)="objectFocus.exutoiregrp = true;searchExutoire($event)"
                        (selectfunction)="selactedArticle.exutoire = $event;" [results]="listExutoire"
                        [label]="'Exutoire'" [defaultselected]="selactedArticle.exutoire" [disablefocus]="true"
                        (keyenterfunction)="selactedArticle.art && selactedArticle.art.id ? showArticleGrp() : common.focusElement('.articlegrp')"
                        [defaultsearch]="selactedArticle.exutoire ? (selactedArticle.exutoire.libelleObjetEntite || selactedArticle.exutoire.nom) : ''">
                      </app-autocomplete>
                    </div>
                    <div class="form-group" *ngIf="societe.qtePrevisionnelle">
                      <label *ngIf="selactedArticle.qte || selactedArticle.qtefocus" style="position: absolute">
                        Qté Prev </label>
                      <input type="number" step="1" class="form-control info" id="qte" placeholder="Qté Prev" autofocus
                        [(ngModel)]="selactedArticle.qte" (focus)="selactedArticle.qtefocus = true;"
                        (blur)="selactedArticle.qtefocus = false;"
                        [ngClass]="{'noValue': !selactedArticle.qte && !selactedArticle.qtefocus}"
                        (keyup.enter)="selactedArticle.art && selactedArticle.art.id ? showArticleGrp() : common.focusElement('.articlegrp')"
                        autocomplete="off">
                    </div>
                    <div class="form-group" *ngIf="societe.axeAnalytiqueLigneBon"
                      [ngClass]="{'disabledbutton': isMouvPraxy}">
                      <label *ngIf="selactedArticle.axeAnalytiqueLigneArt || selactedArticle.axeAnalytiqueLigneArtfocus"
                        style="position: absolute">
                        Axe ana. Art </label>
                      <input type="text" class="form-control info" id="axeAnalytiqueLigneArt" placeholder="Axe ana. Art"
                        autofocus [(ngModel)]="selactedArticle.axeAnalytiqueLigneArt"
                        (focus)="selactedArticle.axeAnalytiqueLigneArtfocus = true;"
                        [ngClass]="{'noValue': !selactedArticle.axeAnalytiqueLigneArt && !selactedArticle.axeAnalytiqueLigneArtfocus}"
                        (keyup.enter)="selactedArticle.art && selactedArticle.art.id ? showArticleGrp() : common.focusElement('.articlegrp')"
                        (blur)="selactedArticle.axeAnalytiqueLignefocus = false;" autocomplete="off">
                    </div>
                  </div>


                  <div class="uppercase col-sm-12" style="margin: 20px 0px;padding: 0px;"
                    [ngStyle]="{'margin-top': objectFocus.articlegrp ? '120px' : (objectFocus.exutoiregrp ? '180px' : '10px') }">
                    <button class="btn-ok" id="okArtGroup"
                      (click)="selactedArticle.art && selactedArticle.art.id ? showArticleGrp() : common.focusElement('.articlegrp');">
                      OK
                    </button>
                    <label>Appuyez sur
                      <b>Entrée</b> pour valider.</label>
                  </div>
                </div>
                <label class="text" *ngIf="!isEditContenant && !addArticle" style=" margin-top: 15px;padding-left: 0px;"
                  (click)=" modifContenant()">Voulez-vous
                  <span class='text-underline uppercase' id="btnModifContenant" (click)=" modifContenant() ">
                    modifier le contenant </span> ?</label>
                <div class="uppercase col-sm-12" *ngIf="!addArticle" style="margin: 30px 0px 0px; padding: 0;"
                  [ngStyle]="{'margin-top': hasSCrollBar('.etape3-phase2') ? '10px': '30px'}">
                  <button class="btn-ok" id="okvalidContenant"
                    (click)="setValue('test','cont',false,false,isEditContenant)">
                    OK
                  </button>
                  <label>Appuyez sur
                    <b>Entrée</b> pour valider.</label>
                </div>
              </div>
              <!-- ajout dans etape 3 -->
            </div>
            <!-- <div *ngSwitchCase="addContenant && !isGroupe ? 5 : 4" class="etape3 choixContenant" style="height:100%">
    
            </div> -->

            <div *ngSwitchCase="addContenant && !isGroupe ? 5 : 4" class="etape2">
              <div style="margin-bottom: 15px">
                <span class="step-title"> Choix de l'exutoire </span>
              </div>
              <div class="form-group" [ngClass]="{'disabledbutton': !edit && isMouvPraxy}">
                <app-autocomplete [placeholder]="'Exutoire'"
                  (searchfunction)="objectFocus.exutoire = true;searchExutoire($event)"
                  (selectfunction)="setValue($event, 'exutoire');defaultExutoir = $event" [results]="listExutoire"
                  [label]="'Exutoire'" [defaultselected]="defaultExutoir"
                  [defaultsearch]="defaultExutoir ? (defaultExutoir.libelleObjetEntite || '') : ''"
                  (keyenterfunction)="defaultExutoir ? (listExutoire.length > 1 || listExutoire.length === 0 ? setValue(defaultExutoir, 'exutoire') : false) : false">
                </app-autocomplete>
              </div>

              <div class="uppercase col-sm-12" style="margin: 80px 0px 0px;padding: 0px;"
                [ngStyle]="{'margin-top': objectFocus.exutoire ? '185px' : '80px' }">
                <button class="btn-ok" id="okExutoire"
                  (click)="defaultExutoir ? setValue(defaultExutoir, 'exutoire') : false">
                  OK
                </button>
                <label>Appuyez sur
                  <b>Entrée</b> pour valider.</label>
              </div>
            </div>
            <div *ngSwitchCase="addContenant && !isGroupe ? 6 : 5" class="etape2">
              <ng-template [ngIf]="!editContenant">
                <div style="margin-bottom: 15px">
                  <span class="step-title"> Choix du type de l'opération </span>
                </div>


                <div class="form-group col-sm-12" [ngClass]="{'disabledbutton': !edit && isMouvPraxy}"
                  style="padding: 0px;">

                  <app-autocomplete *ngIf="defaultSelectedOPeration && defaultSelectedOPeration.id === 0"
                    (focusfunction)="objectFocus.typeOperation = true;"
                    (selectfunction)="setValue($event, 'typeOperation'); defaultSelected = $event;"
                    [results]="dataDepot" [highlight]="true" [isCombo]="true" [label]="'Type de l\'opération'"
                    id="typeOperation" [placeholder]="'Type de l\'opération'" [defaultselected]="defaultSelected"
                    [defaultsearch]="defaultSelected ? defaultSelected.libelleObjetEntite : ''">
                  </app-autocomplete>

                  <app-autocomplete *ngIf="defaultSelectedOPeration && defaultSelectedOPeration.id === 1"
                    (focusfunction)="objectFocus.typeOperation = true;"
                    (selectfunction)="setValue($event, 'typeOperation'); defaultSelected = $event;"
                    [results]="dataRetrait" [highlight]="true" [isCombo]="true" [label]="'Type de l\'opération'"
                    id="typeOperation" [placeholder]="'Type de l\'opération'" [defaultselected]="defaultSelected"
                    [defaultsearch]="defaultSelected ? defaultSelected.libelleObjetEntite : ''">
                  </app-autocomplete>

                  <app-autocomplete *ngIf="defaultSelectedOPeration && defaultSelectedOPeration.id === 2"
                    (focusfunction)="objectFocus.typeOperation = true;"
                    (selectfunction)="setValue($event, 'typeOperation'); defaultSelected = $event;"
                    [results]="dataRotation" [highlight]="true" [isCombo]="true" [label]="'Type de l\'opération'"
                    id="typeOperation" [placeholder]="'Type de l\'opération'" [defaultselected]="defaultSelected"
                    [defaultsearch]="defaultSelected ? defaultSelected.libelleObjetEntite : ''">
                  </app-autocomplete>

                  <app-autocomplete
                    *ngIf="defaultSelectedOPeration && defaultSelectedOPeration.id === 6 && !societe.operationBenneSupp"
                    (focusfunction)="objectFocus.typeOperation = true;"
                    (selectfunction)="setValue($event, 'typeOperation'); defaultSelected = $event;"
                    [results]="dataAutre" [highlight]="true" [isCombo]="true" [label]="'Type de l\'opération'"
                    id="typeOperation" [placeholder]="'Type de l\'opération'" [defaultselected]="defaultSelected"
                    [defaultsearch]="defaultSelected ? defaultSelected.libelleObjetEntite : ''">
                  </app-autocomplete>

                  <app-autocomplete *ngIf="societe.operationBenneSupp  && defaultSelectedOPeration && defaultSelectedOPeration.id !== 0 && defaultSelectedOPeration.id !== 1
                      && defaultSelectedOPeration.id !== 2  && isBenneEnPlace(defaultSelectedOPeration) "
                    (focusfunction)="objectFocus.typeOperation = true;"
                    (selectfunction)="setValue($event, 'typeOperation'); defaultSelected = $event;"
                    [results]="dataOppSuppBennePlace" [highlight]="true" [isCombo]="true"
                    [label]="'Type de l\'opération'" id="typeOperation" [placeholder]="'Type de l\'opération'"
                    [defaultselected]="defaultSelected"
                    [defaultsearch]="defaultSelected ? defaultSelected.libelleObjetEntite : ''">
                  </app-autocomplete>

                  <app-autocomplete *ngIf="societe.operationBenneSupp  && defaultSelectedOPeration && defaultSelectedOPeration.id !== 0 && defaultSelectedOPeration.id !== 1
                      && defaultSelectedOPeration.id !== 2  && isBenneNonEnPlace(defaultSelectedOPeration)"
                    (focusfunction)="objectFocus.typeOperation = true;"
                    (selectfunction)="setValue($event, 'typeOperation'); defaultSelected = $event;"
                    [results]="dataOppSupp" [highlight]="true" [isCombo]="true" [label]="'Type de l\'opération'"
                    id="typeOperation" [placeholder]="'Type de l\'opération'" [defaultselected]="defaultSelected"
                    [defaultsearch]="defaultSelected ? defaultSelected.libelleObjetEntite : ''">
                  </app-autocomplete>


                  <app-autocomplete
                    *ngIf="!societe.operationBenneSupp  && defaultSelectedOPeration && defaultSelectedOPeration.id !== 0 && defaultSelectedOPeration.id !== 1
                      && defaultSelectedOPeration.id !== 2 && defaultSelectedOPeration.id !== 6 && isBenneEnPlace(defaultSelectedOPeration) "
                    (focusfunction)="objectFocus.typeOperation = true;"
                    (selectfunction)="setValue($event, 'typeOperation'); defaultSelected = $event;"
                    [results]="dataOppSuppBennePlace" [highlight]="true" [isCombo]="true"
                    [label]="'Type de l\'opération'" id="typeOperation" [placeholder]="'Type de l\'opération'"
                    [defaultselected]="defaultSelected"
                    [defaultsearch]="defaultSelected ? defaultSelected.libelleObjetEntite : ''">
                  </app-autocomplete>

                  <app-autocomplete
                    *ngIf="!societe.operationBenneSupp  && defaultSelectedOPeration && defaultSelectedOPeration.id !== 0 && defaultSelectedOPeration.id !== 1
                      && defaultSelectedOPeration.id !== 2 && defaultSelectedOPeration.id !== 6 && isBenneNonEnPlace(defaultSelectedOPeration)"
                    (focusfunction)="objectFocus.typeOperation = true;"
                    (selectfunction)="setValue($event, 'typeOperation'); defaultSelected = $event;"
                    [results]="dataOppSupp" [highlight]="true" [isCombo]="true" [label]="'Type de l\'opération'"
                    id="typeOperation" [placeholder]="'Type de l\'opération'" [defaultselected]="defaultSelected"
                    [defaultsearch]="defaultSelected ? defaultSelected.libelleObjetEntite : ''">
                  </app-autocomplete>

                </div>
                <div class="form-group col-sm-12" [ngClass]="{'disabledbutton': !edit && isMouvPraxy}"
                  style="padding: 0px;" *ngIf="societe.operationBenneSupp && societe.operationBenneParDefaut && dataisOpSurBenneEnPlace && dataisOpSurBenneEnPlace.length &&
                                    defaultSelected && (defaultSelected.id !== 0 && defaultSelected.id !== 1)">
                  <app-autocomplete (focusfunction)="objectFocus.champOperationDefaut = true;"
                    (selectfunction)="setValue($event, 'champOperationDefaut'); defaultSelectedDefaut = $event;"
                    [results]="dataisOpSurBenneEnPlace" [highlight]="true" [isCombo]="true" [label]="'Op. par defaut'"
                    id="champOperationDefaut" [placeholder]="'Op. par defaut'" [defaultselected]="defaultSelectedDefaut"
                    [defaultsearch]="defaultSelectedDefaut ? defaultSelectedDefaut.libelleObjetEntite : ''">
                  </app-autocomplete>
                </div>

                <div class="uppercase col-sm-12" style="margin: 185px 0px 0px;padding: 0px;"
                  [ngStyle]="{'margin-top': objectFocus.typeOperation ? '185px' : '80px' }">
                  <button class="btn-ok" id="okChoixOp"
                    (click)="defaultSelected ? setValue(defaultSelected, 'typeOperation', false, true) : setValue(defaultSelected, 'ope')">
                    OK
                  </button>
                  <label>Appuyez sur
                    <b>Entrée</b> pour valider.</label>
                </div>
              </ng-template>
              <ng-template [ngIf]="editContenant">
                <!-- <div style="margin-bottom: 15px">
                  <span class="step-title">{{ "Choix de la date, de l'heure et de l'opération" }} </span>
                </div> -->
                <div class="form-group col-sm-12" [ngClass]="{'disabledbutton': !edit && isMouvPraxy}"
                  style="padding: 0; margin: 0;" id="editTop">
                  <div class="col-sm-12" style="padding: 0">
                    <div class="col-sm-6" style="padding: 0 5px 0 0">

                      <div class="col-sm-12 form-group" style="padding: 0">
                        <label class="col-sm-12 labelDate"> Date :
                          <!-- <span class="pull-right">{{common.isDate(newprest.dateStart)}}</span> -->
                        </label>
                        <app-input-date [container]="true" [closeDatepickerOnSelect]="true"
                          [class]="'col-sm-12 form-control dateAvecLabel'" [id]="'date1'" [model]="newprest.dateStart"
                          (changefct)="newprest.dateStart = $event; changeDateStart($event); showDate = true"
                          [placeholder]="'Date debut'"
                          (keyenterfct)="common.changeDate($event, newprest.dateStart, '#h1');"
                          (selectfct)="selectDate($event, '#date1')" [showDatepicker]="true">
                        </app-input-date>
                      </div>
                    </div>
                    <div class="col-sm-6" style="padding: 0 0 0 5px">
                      <ng-template [ngIf]="societe.dateDemandeManuel ">

                        <div class="col-sm-12 form-group" style="padding: 0"
                          [ngClass]="{'disabledbutton': isMouvPraxy}">
                          <label class="col-sm-12 labelDate"> Date Dem. :
                            <!-- <span class="pull-right">{{newprest.dateDemandeManuel ||
                            ''}}</span> -->
                          </label>
                          <app-input-date [container]="true" [closeDatepickerOnSelect]="true"
                            [class]="'col-sm-12 form-control  dateAvecLabel'" [id]="'dateDmd'"
                            [model]="newprest.dateDemandeManuelModel"
                            (changefct)="newprest.dateDemandeManuelModel = $event; changeDateDmD('dateDemandeManuel', $event)"
                            [placeholder]="'Date Demande'" [dateVide]="true"
                            (keyenterfct)="common.changeDate($event, newprest.dateDemandeManuel, '#h1');"
                            (selectfct)="selectDate($event, '#dateDmd')" [showDatepicker]="true">
                          </app-input-date>
                        </div>
                      </ng-template>
                    </div>

                    <ng-template [ngIf]="societe.gestionDateMax ">

                      <div class="col-sm-12 form-group" style="padding: 0"
                        [ngClass]="{'disabledbutton': isMouvPraxy || edit}">
                        <label class="col-sm-12 labelDate"> Date Max :
                          <!-- <span style="margin-left: 147px;">{{common.isDate(newprest.dateMaxStart)}}</span> -->
                        </label>
                        <app-input-date [container]="true" [closeDatepickerOnSelect]="true"
                          [class]="'col-sm-12 form-control dateAvecLabel'" [id]="'date2'"
                          [model]="newprest.dateMaxStart" (changefct)="newprest.dateMaxStart = $event;"
                          [placeholder]="'Date Max'"
                          (keyenterfct)="common.changeDate($event, newprest.dateMaxStart, '#h1');"
                          (selectfct)="selectDate($event, '#date1')" [showDatepicker]="true">
                        </app-input-date>
                      </div>
                    </ng-template>
                    <div class="form-group col-sm-12" id="checkAuplutard" style="padding: 0; margin-bottom: 15px;">
                      <mat-checkbox [color]="'primary'" [(ngModel)]="newprest.auPlusTard">
                        <label>Au + Tard</label>
                      </mat-checkbox>
                    </div>

                    <div class="col-sm-12 form-group" style="padding: 0">
                      <label class="col-sm-12 labelDate" *ngIf="newprest.heurefocus || newprest.hour"> Heure : </label>
                      <input type="text" class="form-control info" id="h1" placeholder="Heure"
                        [(ngModel)]="newprest.hour"
                        (keydown.enter)=" showDate = true;setValue(true, 'showdate'); common.clickElement('.typeOperation')"
                        [ngClass]="{'noValue': !newprest.heurefocus && (!newprest.hour || newprest.hour === '')}"
                        (focus)="newprest.heurefocus = true;" (blur)="newprest.heurefocus = false;" autocomplete="off">
                    </div>
                  </div>
                  <div class="form-group col-sm-12 p-0">
                    <div class="col-sm-6" style="padding: 0 5px 0 0"
                      *ngIf="!isGroupe &&newprest.contenant && !newprest.contenant.isGroupeArticle">
                      <app-autocomplete [placeholder]="'Article'" id="articleCont"
                        (searchfunction)="objectFocus.article = true;searchArticle($event)"
                        (selectfunction)="newprest.contenant.art = $event;  common.focusElement('.articleCont');   actualiseArt(newprest.contenant.art, newprest.contenant);"
                        [results]="listArticle" [label]="'Article'" [container]="true"
                        (keyenterfunction)="newprest.contenant.art ?  setValue('test', 'cont')  : false"
                        [defaultselected]="newprest.contenant.art"
                        [defaultsearch]="newprest.contenant.art ? newprest.contenant.art.libelleObjetEntite : ''">
                      </app-autocomplete>
                    </div>
                    <div class="col-sm-6" style=" padding: 0 0 0 5px;">
                      <app-autocomplete [placeholder]="'Exutoire'"
                        (searchfunction)="objectFocus.exutoire = true;searchExutoire($event)"
                        (selectfunction)="setValue($event, 'exutoire');defaultExutoir = $event" [results]="listExutoire"
                        [label]="'Exutoire'" [defaultselected]="defaultExutoir"
                        [defaultsearch]="defaultExutoir ? (defaultExutoir.libelleObjetEntite || '') : ''"
                        (keyenterfunction)="defaultExutoir ? (listExutoire.length > 1 || listExutoire.length === 0 ? setValue(defaultExutoir, 'exutoire') : false) : false">
                      </app-autocomplete>
                    </div>
                  </div>

                  <div class="form-group col-sm-12 p-0" *ngIf="!isGroupe">
                    <div class=" col-sm-9" [ngClass]="{'disabledbutton': !edit && isMouvPraxy}"
                      style="padding: 0 5px 0 0">
                      <app-autocomplete *ngIf="defaultSelectedOPeration && defaultSelectedOPeration.id === 0"
                        (focusfunction)="objectFocus.typeOperation = true;"
                        (selectfunction)="setValue($event, 'typeOperation'); defaultSelected = $event;"
                        [results]="dataDepot" [highlight]="true" [isCombo]="true" [label]="'Type d\'opération'"
                        id="typeOperation" [placeholder]="'Type d\'opération'" [defaultselected]="defaultSelected"
                        [defaultsearch]="defaultSelected ? defaultSelected.libelleObjetEntite : ''">
                      </app-autocomplete>

                      <app-autocomplete *ngIf="defaultSelectedOPeration && defaultSelectedOPeration.id === 1"
                        (focusfunction)="objectFocus.typeOperation = true;"
                        (selectfunction)="setValue($event, 'typeOperation'); defaultSelected = $event;"
                        [results]="dataRetrait" [highlight]="true" [isCombo]="true" [label]="'Type d\'opération'"
                        id="typeOperation" [placeholder]="'Type d\'opération'" [defaultselected]="defaultSelected"
                        [defaultsearch]="defaultSelected ? defaultSelected.libelleObjetEntite : ''">
                      </app-autocomplete>

                      <app-autocomplete *ngIf="defaultSelectedOPeration && defaultSelectedOPeration.id === 2"
                        (focusfunction)="objectFocus.typeOperation = true;"
                        (selectfunction)="setValue($event, 'typeOperation'); defaultSelected = $event;"
                        [results]="dataRotation" [highlight]="true" [isCombo]="true" [label]="'Type d\'opération'"
                        id="typeOperation" [placeholder]="'Type d\'opération'" [defaultselected]="defaultSelected"
                        [defaultsearch]="defaultSelected ? defaultSelected.libelleObjetEntite : ''">
                      </app-autocomplete>

                      <app-autocomplete
                        *ngIf="defaultSelectedOPeration && defaultSelectedOPeration.id === 6 && !societe.operationBenneSupp"
                        (focusfunction)="objectFocus.typeOperation = true;"
                        (selectfunction)="setValue($event, 'typeOperation'); defaultSelected = $event;"
                        [results]="dataAutre" [highlight]="true" [isCombo]="true" [label]="'Type d\'opération'"
                        id="typeOperation" [placeholder]="'Type d\'opération'" [defaultselected]="defaultSelected"
                        [defaultsearch]="defaultSelected ? defaultSelected.libelleObjetEntite : ''">
                      </app-autocomplete>


                      <app-autocomplete
                        *ngIf="societe.operationBenneSupp  && defaultSelectedOPeration && defaultSelectedOPeration.id !== 0 && defaultSelectedOPeration.id !== 1
                                      && defaultSelectedOPeration.id !== 2 && isBenneEnPlace(defaultSelectedOPeration) "
                        (focusfunction)="objectFocus.typeOperation = true;"
                        (selectfunction)="setValue($event, 'typeOperation'); defaultSelected = $event;"
                        [results]="dataOppSuppBennePlace" [highlight]="true" [isCombo]="true"
                        [label]="'Type d\'opération'" id="typeOperation" [placeholder]="'Type d\'opération'"
                        [defaultselected]="defaultSelected"
                        [defaultsearch]="defaultSelected ? defaultSelected.libelleObjetEntite : ''">
                      </app-autocomplete>

                      <app-autocomplete
                        *ngIf="societe.operationBenneSupp  && defaultSelectedOPeration && defaultSelectedOPeration.id !== 0 && defaultSelectedOPeration.id !== 1
                                        && defaultSelectedOPeration.id !== 2 && isBenneNonEnPlace(defaultSelectedOPeration)"
                        (focusfunction)="objectFocus.typeOperation = true;"
                        (selectfunction)="setValue($event, 'typeOperation'); defaultSelected = $event;"
                        [results]="dataOppSupp" [highlight]="true" [isCombo]="true" [label]="'Type d\'opération'"
                        id="typeOperation" [placeholder]="'Type d\'opération'" [defaultselected]="defaultSelected"
                        [defaultsearch]="defaultSelected ? defaultSelected.libelleObjetEntite : ''">
                      </app-autocomplete>


                      <app-autocomplete
                        *ngIf="!societe.operationBenneSupp  && defaultSelectedOPeration && defaultSelectedOPeration.id !== 0 && defaultSelectedOPeration.id !== 1
                                        && defaultSelectedOPeration.id !== 2 && defaultSelectedOPeration.id !== 6 && isBenneEnPlace(defaultSelectedOPeration) "
                        (focusfunction)="objectFocus.typeOperation = true;"
                        (selectfunction)="setValue($event, 'typeOperation'); defaultSelected = $event;"
                        [results]="dataOppSuppBennePlace" [highlight]="true" [isCombo]="true"
                        [label]="'Type d\'opération'" id="typeOperation" [placeholder]="'Type d\'opération'"
                        [defaultselected]="defaultSelected"
                        [defaultsearch]="defaultSelected ? defaultSelected.libelleObjetEntite : ''">
                      </app-autocomplete>

                      <app-autocomplete
                        *ngIf="!societe.operationBenneSupp  && defaultSelectedOPeration && defaultSelectedOPeration.id !== 0 && defaultSelectedOPeration.id !== 1
                                        && defaultSelectedOPeration.id !== 2 && defaultSelectedOPeration.id !== 6 && isBenneNonEnPlace(defaultSelectedOPeration)"
                        (focusfunction)="objectFocus.typeOperation = true;"
                        (selectfunction)="setValue($event, 'typeOperation'); defaultSelected = $event;"
                        [results]="dataOppSupp" [highlight]="true" [isCombo]="true" [label]="'Type d\'opération'"
                        id="typeOperation" [placeholder]="'Type d\'opération'" [defaultselected]="defaultSelected"
                        [defaultsearch]="defaultSelected ? defaultSelected.libelleObjetEntite : ''">
                      </app-autocomplete>

                    </div>
                    <div class="col-sm-3" [ngClass]="{'disabledbutton': !edit && isMouvPraxy}"
                      style="padding: 0 0 0 5px"
                      *ngIf="!isGroupe && newprest.contenant && newprest.contenant.typeContenant && !newprest.contenant.typeContenant.isUnitaire">
                      <app-autocomplete [placeholder]="'Qté cont.'" [id]="'listQteId'"
                        (selectfunction)="qteSelected = $event; setValueQte(); setValue('test', 'cont')"
                        [isCombo]="true" [results]="listQte" [label]="'Qté cont.'" [defaultselected]="qteSelected"
                        [defaultsearch]="qteSelected ? qteSelected.libelleObjetEntite : ''" [activeDropUp]="true"
                        (keyenterfunction)="setValueQte(); setValue('test', 'cont')">
                      </app-autocomplete>
                    </div>
                  </div>
                  <div class="form-group col-sm-12" [ngClass]="{'disabledbutton': !edit && isMouvPraxy}"
                    style="position: relative; padding: 0;"
                    *ngIf="newprest.client && newprest.client.numBonManuelObligatoire">
                    <label *ngIf="newprest.numBonfocus || newprest.numBonManuel" style="position: absolute;"> N° de Bon
                      manuel
                    </label>
                    <input type="text" class="form-control info" id="numbon" placeholder="N° de Bon manuel" autofocus
                      [(ngModel)]="newprest.numBonManuel" (keyup.enter)="common.focusNext('.divers')"
                      [ngClass]="{'noValue': !newprest.numBonfocus && (!newprest.numBonManuel || newprest.numBonManuel === '')}"
                      (focus)="newprest.numBonfocus = true;" (blur)="newprest.numBonfocus = false;" autocomplete="off">
                  </div>
                  <ng-template [ngIf]="!isGroupe">
                    <!-- [ngIf]="contenantVert && !isGroupe" -->
                    <div class="form-group col-sm-12 p-0" style="position: relative;">
                      <label *ngIf="newprest.numBSDDfocus || newprest.numBSDD" style="position: absolute;
                      font-size: 11px;
                      text-align: left;
                      color: rgba(55, 97, 148, 0.6);
                      padding: 4px 8px;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      font-weight: 700;"> N° de BSD manuel
                      </label>
                      <input type="text" class="form-control info" placeholder="N° de BSD manuel" id="numbsdd"
                        [(ngModel)]="newprest.numBSDD" (keyup.enter)="setValue(true, 'divers')"
                        [ngClass]="{'noValue': !newprest.numBSDDfocus && (!newprest.numBSDD || newprest.numBSDD === '')}"
                        (focus)="newprest.numBSDDfocus = true;" (blur)="newprest.numBSDDfocus = false;"
                        autocomplete="off">
                    </div>
                  </ng-template>
                  <ng-template [ngIf]="isAmiante && !isGroupe">
                    <div class="form-group col-sm-12 p-0" style="position: relative;"
                      [ngClass]="{'disabledbutton': !edit && isMouvPraxy}">
                      <label *ngIf="newprest.numScellefocus || newprest.numScelle" style="position: absolute;
                      font-size: 11px;
                      text-align: left;
                      color: rgba(55, 97, 148, 0.6);
                      padding: 4px 8px;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      font-weight: 700;"> Num Scellé
                      </label>
                      <input type="text" class="form-control info" placeholder="Num Scellé" id="numScelle"
                        [(ngModel)]="newprest.numScelle" (keyup.enter)="setValue(true, 'divers')"
                        [ngClass]="{'noValue': !newprest.numScellefocus && (!newprest.numScelle || newprest.numScelle === '')}"
                        (focus)="newprest.numScellefocus = true;" (blur)="newprest.numScellefocus = false;"
                        autocomplete="off">
                    </div>
                  </ng-template>

                  <div class=" col-sm-12 p-0 form-group" [ngClass]="{'disabledbutton': isMouvPraxy}">
                    <label *ngIf="newprest.infomvtfocus || newprest.infoNextMouv" style="position: absolute;"> Infos
                      prestation
                    </label>
                    <textarea type="text" class="form-control info" placeholder="Infos prestation" id="infomvt"
                      [(ngModel)]="newprest.infoNextMouv" style="height: auto;" (focus)="newprest.infomvtfocus = true;"
                      (blur)="newprest.infomvtfocus = false;" autocomplete="off">
                      </textarea>
                    <div class="uppercase" style="font-size: 11px; margin-top: 3px;" *ngIf="newprest.infosuppfocus">
                      Taper
                      sur TAB
                      <span class="icontab">&#x21B9;</span> pour valider
                    </div>
                  </div>
                  <div class=" col-sm-12 p-0 form-group" id="checkPrestImportant"
                    [ngClass]="{'disabledbutton': isMouvPraxy}">
                    <mat-checkbox [color]="'primary'" [(ngModel)]="newprest.isImportant">
                      <label>Prestation importante</label>
                    </mat-checkbox>
                  </div>
                </div>


                <div class="list-group col-sm-12" [ngClass]="{'disabledbutton': !edit && isMouvPraxy}" *ngIf="isGroupe"
                  style="overflow-y: hidden; overflow-x: hidden; max-height: calc(100% - 450px);padding: 0;"
                  [ngStyle]="{'height': newprest.client && newprest.client.numBonManuelObligatoire ? 'calc(100% - ' + calcHeightDatatable() + 'px)' : 'calc(100% - ' + calcHeightDatatable() + 'px)'}">
                  <cdk-virtual-scroll-viewport [itemSize]="120" style="width: 100%; ">
                    <ng-container
                      *cdkVirtualFor="let item of listBenneSelected;trackBy:common.trackById; let i = index;">
                      <li class="list-group-item container" id="autofocus0{{i}}" (keyup)="changeFocusCont($event, i)"
                        style=" padding: 5px 2px; font-size: 13px;" tabindex="{{i}}"
                        [ngStyle]="{'height': item.art && item.art.amiante ? '165px' : '120px'}">
                        <!-- [ngClass]="{'contenantGroupe': selectedContenant(item)}" -->

                        <div class="col-sm-12 p-0">
                          <div class="col-sm-12 p-0" style="margin-bottom: 5px;">
                            <div class="col-sm-9 benne" style="max-height: 75px;">

                              <div style="width: 40px; position: relative; padding-right: 0px;">
                                <ng-template [ngIf]="item.id && item.id < 0">
                                  <div class=""
                                    [ngClass]="{'disabledbutton': item && item.typeContenant && item.typeContenant.isUnitaire}">
                                    <label *ngIf="item.qteContenant || newprest.qteContenantfocus"
                                      style="position: absolute;font-size: 11px;text-align: left;color: rgba(55, 97, 148, 0.6);padding: 4px 8px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                                      Qté </label>
                                    <input type="number" step="1" class="form-control info" id="qteContenant"
                                      placeholder="Qté" autofocus [(ngModel)]="item.qteContenant"
                                      (focus)="newprest.qteContenantfocus = true;" style="height: 47px;"
                                      (blur)="newprest.qteContenantfocus = false;" autocomplete="off">
                                  </div>
                                </ng-template>
                                <ng-template [ngIf]="item.id && item.id > 0">
                                  <div class=""
                                    [ngClass]="{'disabledbutton': item && item.typeContenant && item.typeContenant.isUnitaire}"
                                    (click)="listQteComboGroup(item)">
                                    <app-autocomplete [placeholder]="'Qté'" [id]="'listQteId'"
                                      (searchfunction)="listQteComboGroup(item)" [showonclick]="true"
                                      (selectfunction)="item.qteContenant = $event.libelleObjetEntite;" [isCombo]="true"
                                      [results]="item.listQte" [label]="'Qté'" [defaultselected]="qteSelected"
                                      [container]="true" [selectvalue]="true" [disablefocus]="true"
                                      [defaultsearch]="item.qteContenant || ''">
                                    </app-autocomplete>
                                  </div>
                                </ng-template>
                              </div>
                              <div class="text-left  " style="padding: 0px 5px; width: calc(100% - 40px);"
                                [ngStyle]="{'width': 'calc(100% - 40px)' }">
                                <div *ngIf="!item.isGroupeBenne" class="col-sm-12 ellipsis" style="padding: 0px;">
                                  <div class="col-sm-12" style="padding: 0;margin-bottom: 5px;"
                                    *ngIf="isEditableTypeContenant">
                                    <app-autocomplete
                                      (selectfunction)="item.typeContenant = $event; common.focusElement('.articleCont')"
                                      [results]="typeContenant" [highlight]="true" [showonclick]="true"
                                      (searchfunction)="searchTypecontenantByLibelle($event)" [container]="true"
                                      [label]="'Type contenant'" id="typeContDep" [placeholder]="'Type contenant'"
                                      (keyenterfunction)="common.focusElement('.articleCont')"
                                      [defaultselected]="item.typeContenant" [selectvalue]="true" [disablefocus]="true"
                                      [defaultsearch]="item.typeContenant ? item.typeContenant.libelleObjetEntite : ''">
                                    </app-autocomplete>
                                  </div>

                                  <div class="col-sm-12"
                                    style="padding: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                                    *ngIf="!isEditableTypeContenant">
                                    <span *ngIf="item.typeContenant && item.typeContenant.famille">
                                      {{item.typeContenant.famille.libelle}}
                                    </span>
                                    <span *ngIf="item.typeContenant && item.typeContenant.cubage">
                                      {{item.typeContenant.cubage.cubage || '0'}}</span>
                                    <span *ngIf="item.typeContenant && item.typeContenant.uniteCont">
                                      {{item.typeContenant.uniteCont.libelle}} </span>
                                  </div>

                                  <div *ngIf="item.isGroupeArticle" class="col-sm-12 ellipsis" style="padding: 0px;">
                                    Grp Art
                                  </div>
                                  <div class="col-sm-12 ellipsis" *ngIf="item.art && !item.isGroupeArticle"
                                    style="padding: 0px; width: 99%; overflow: hidden;"
                                    [ngStyle]="{'white-space': 'nowrap'}">
                                    {{item.art.code}} {{item.isGroupeArticle? '': '/' }} {{item.art.libelle ||
                                    item.art.libelleObjetEntite}}
                                  </div>
                                  <div class="col-sm-12 ellipsis" style="padding: 0px;" *ngIf="item.isLocation">
                                    <span> Location </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- <app-contenant [item]="item" [addClassGroupCreate]="true" [champQte]="true"
                            [showAllArticle]="true" [common]="common" [showNotif]="true">
                          </app-contenant> -->
                            <div class="col-sm-3 p-0">
                              <app-autocomplete *ngIf="item.operationBenne && item.operationBenne.id === 0"
                                (focusfunction)="objectFocus.typeOperation = true;"
                                (selectfunction)="item.operationBenne = $event;actualiseOperation(item);"
                                [container]="true" [results]="dataDepot" [highlight]="true" [isCombo]="true"
                                [label]="'Opération'" id="typeOperation" [placeholder]="'Opération'"
                                [defaultselected]="item.operationBenne" [disablefocus]="true"
                                [defaultsearch]="item.operationBenne ? (item.operationBenne.libelleObjetEntite ) : ''">
                              </app-autocomplete>

                              <app-autocomplete *ngIf="item.operationBenne && item.operationBenne.id === 1"
                                (focusfunction)="objectFocus.typeOperation = true;" [container]="true"
                                (selectfunction)="item.operationBenne = $event;actualiseOperation(item);"
                                [results]="dataRetrait" [highlight]="true" [isCombo]="true" [label]="'Opération'"
                                id="typeOperation" [placeholder]="'Opération'" [defaultselected]="item.operationBenne"
                                [disablefocus]="true"
                                [defaultsearch]="item.operationBenne ? (item.operationBenne.libelleObjetEntite ) : ''">
                              </app-autocomplete>

                              <app-autocomplete *ngIf="item.operationBenne && item.operationBenne.id === 2"
                                (focusfunction)="objectFocus.typeOperation = true;" [container]="true"
                                (selectfunction)="item.operationBenne = $event;actualiseOperation(item);"
                                [results]="dataRotation" [highlight]="true" [isCombo]="true" [label]="'Opération'"
                                id="typeOperation" [disablefocus]="true" [placeholder]="'Opération'"
                                [defaultselected]="item.operationBenne"
                                [defaultsearch]="item.operationBenne ? (item.operationBenne.libelleObjetEntite ) : ''">
                              </app-autocomplete>

                              <app-autocomplete
                                *ngIf="item.operationBenne && item.operationBenne.id === 6 && !societe.operationBenneSupp"
                                (focusfunction)="objectFocus.typeOperation = true;"
                                (selectfunction)="item.operationBenne = $event;actualiseOperation(item);"
                                [container]="true" [results]="dataAutre" [highlight]="true" [isCombo]="true"
                                [label]="'Opération'" id="typeOperation" [placeholder]="'Opération'"
                                [defaultselected]="item.operationBenne" [disablefocus]="true"
                                [defaultsearch]="item.operationBenne ? (item.operationBenne.libelleObjetEntite ) : ''">
                              </app-autocomplete>

                              <app-autocomplete *ngIf="societe.operationBenneSupp  && item.operationBenne && item.operationBenne.id !== 0 && item.operationBenne.id !== 1
                                  && item.operationBenne.id !== 2 && item.isBenneEnPlace"
                                (focusfunction)="objectFocus.typeOperation = true;"
                                (selectfunction)="item.operationBenne = $event;actualiseOperation(item);"
                                [container]="true" [results]="dataOppSuppBennePlace" [highlight]="true" [isCombo]="true"
                                [disablefocus]="true" [label]="'Opération'" id="typeOperation"
                                [placeholder]="'Opération'" [defaultselected]="item.operationBenne"
                                [defaultsearch]="item.operationBenne ? (item.operationBenne.libelleObjetEntite ) : ''">
                              </app-autocomplete>

                              <app-autocomplete *ngIf="societe.operationBenneSupp  && item.operationBenne && item.operationBenne.id !== 0 && item.operationBenne.id !== 1
                                  && item.operationBenne.id !== 2 && item.isBenneNonEnPlace"
                                (focusfunction)="objectFocus.typeOperation = true;"
                                (selectfunction)="item.operationBenne = $event;actualiseOperation(item);"
                                [container]="true" [results]="dataOppSupp" [highlight]="true" [isCombo]="true"
                                [label]="'Opération'" id="typeOperation" [placeholder]="'Opération'"
                                [defaultselected]="item.operationBenne" [disablefocus]="true"
                                [defaultsearch]="item.operationBenne ? (item.operationBenne.libelleObjetEntite ) : ''">
                              </app-autocomplete>

                              <app-autocomplete
                                *ngIf="!societe.operationBenneSupp  && item.operationBenne && item.operationBenne.id !== 0 && item.operationBenne.id !== 1
                                  && item.operationBenne.id !== 2 && item.operationBenne.id !== 6 && item.isBenneEnPlace"
                                (focusfunction)="objectFocus.typeOperation = true;"
                                (selectfunction)="item.operationBenne = $event;actualiseOperation(item);"
                                [container]="true" [results]="dataOppSuppBennePlace" [highlight]="true" [isCombo]="true"
                                [label]="'Opération'" id="typeOperation" [placeholder]="'Opération'"
                                [defaultselected]="defaultSelected" [disablefocus]="true"
                                [defaultsearch]="item.operationBenne ? (item.operationBenne.libelleObjetEntite ) : ''">
                              </app-autocomplete>

                              <app-autocomplete
                                *ngIf="!societe.operationBenneSupp  && item.operationBenne && item.operationBenne.id !== 0 && item.operationBenne.id !== 1
                                  && item.operationBenne.id !== 2 && item.operationBenne.id !== 6 && item.isBenneNonEnPlace"
                                (focusfunction)="objectFocus.typeOperation = true;"
                                (selectfunction)="item.operationBenne = $event;actualiseOperation(item);"
                                [container]="true" [results]="dataOppSupp" [highlight]="true" [isCombo]="true"
                                [label]="'Opération'" id="typeOperation" [placeholder]="'Opération'"
                                [defaultselected]="defaultSelected" [disablefocus]="true"
                                [defaultsearch]="item.operationBenne ? (item.operationBenne.libelleObjetEntite ) : ''">
                              </app-autocomplete>

                            </div>
                            <!-- <div class="col-sm-2 text-center pt-2">
                              <button class="btn-detail" (click)="item.isChecked = false;selectContenantForGroup(item)">
                                <i class="fa fa-trash"></i>
                              </button>
                            </div> -->
                          </div>

                          <div class=" col-sm-12 p-0" style="position: relative;">
                            <label style="position: absolute;
                        margin: 0;z-index: 5;" *ngIf="item.numBSDDfocus || item.numBSDDManuel"> N° de BSD
                              manuel
                            </label>
                            <input type="text" style="position: relative;
                        opacity: 1;" class="form-control info" placeholder="N° de BSD manuel"
                              [(ngModel)]="item.numBSDDManuel" (keyup.enter)="setValue(true, 'divers')"
                              (focus)="item.numBSDDfocus = true;" (blur)="item.numBSDDfocus = false;"
                              [ngStyle]="{'padding': !item.numBSDDfocus && !item.numBSDDManuel ? '8px 10px 0 10px' : '16px 10px 0px'}"
                              autocomplete="off">
                          </div>
                          <div class=" col-sm-12 p-0" *ngIf="item.art && item.art.amiante"
                            style="position: relative;margin-top: 5px;">
                            <label style="position: absolute;
                        margin: 0;z-index: 5;" *ngIf="item.numScellefocus || item.numScelle">Num Scellé
                            </label>
                            <input type="text" style="position: relative;
                        opacity: 1;" class="form-control info" placeholder="Num Scellé" [(ngModel)]="item.numScelle"
                              (keyup.enter)="setValue(true, 'divers')" (focus)="item.numScellefocus = true;"
                              (blur)="item.numScellefocus = false;"
                              [ngStyle]="{'padding': !item.numScellefocus && !item.numScelle ? '8px 10px 0 10px' : '16px 10px 0px'}"
                              autocomplete="off">
                          </div>

                        </div>

                      </li>
                    </ng-container>

                  </cdk-virtual-scroll-viewport>

                </div>

                <div class="uppercase col-sm-12" style="margin: 185px 0px 0px;padding: 0px;"
                  [ngStyle]="{'margin-top': isGroupe ? '10px' : (objectFocus.typeOperation ? '185px' : '80px') }">
                  <button class="btn-ok"
                    (click)="(defaultSelected ? setValue(defaultSelected, 'typeOperation') : setValue(defaultSelected, 'ope')); generatePrestation();">
                    OK
                  </button>
                  <label>Appuyez sur
                    <b>Entrée</b> pour valider.</label>
                </div>
              </ng-template>
            </div>
            <div *ngSwitchCase="addContenant && !isGroupe ? 3 : 6" class="etape2">
              <div style="margin-bottom: 15px">
                <span class="step-title">Choix de la date et de l'heure</span>
              </div>
              <div class="form-group col-sm-12" style="padding: 0">
                <div class="col-sm-12" style="padding: 0">
                  <span class="col-sm-12" style="padding: 0"> Date :
                    <span style="margin-left: 147px;">{{common.isDate(newprest.dateStart)}}</span>
                  </span>
                  <div class="col-sm-12 form-group" style="padding: 0" [ngClass]="{'disabledbutton': isMouvPraxy}">
                    <app-input-date [container]="true" [closeDatepickerOnSelect]="true" [class]="'col-sm-12 date'"
                      [id]="'date1'" [model]="newprest.dateStart"
                      (changefct)="newprest.dateStart = $event; changeDateStart($event); showDate = true"
                      [placeholder]="'Date debut'" (keyenterfct)="common.changeDate($event, newprest.dateStart, '#h1');"
                      (selectfct)="selectDate($event, '#date1')" [showDatepicker]="true">
                    </app-input-date>
                  </div>
                  <!-- Demande -->
                  <ng-template [ngIf]="societe.dateDemandeManuel ">
                    <span class="col-sm-12" style="padding: 0"> Date Dem. :
                      <span style="margin-left: 147px;">{{newprest.dateDemandeManuel ||
                        ''}}</span>
                    </span>
                    <div class="col-sm-12 form-group" style="padding: 0"
                      [ngClass]="{'disabledbutton': isMouvPraxy || isEcoDDS}">
                      <app-input-date [container]="true" [closeDatepickerOnSelect]="true" [class]="'col-sm-12 date'"
                        [id]="'dateDmd'" [model]="newprest.dateDemandeManuelModel"
                        (changefct)="newprest.dateDemandeManuelModel = $event; changeDateDmD('dateDemandeManuel', $event)"
                        [placeholder]="'Date Demande'" [dateVide]="true"
                        (keyenterfct)="common.changeDate($event, newprest.dateDemandeManuel, '#h1');"
                        (selectfct)="selectDate($event, '#dateDmd')" [showDatepicker]="true">
                      </app-input-date>
                    </div>
                  </ng-template>

                  <ng-template [ngIf]="societe.gestionDateMax ">
                    <span class="col-sm-12" style="padding: 0"> Date Max :
                      <span style="margin-left: 147px;">{{common.isDate(newprest.dateMaxStart)}}</span>
                    </span>
                    <div class="col-sm-12 form-group" style="padding: 0"
                      [ngClass]="{'disabledbutton': isMouvPraxy || isEcoDDS || edit}">
                      <app-input-date [container]="true" [closeDatepickerOnSelect]="true" [class]="'col-sm-12 date'"
                        [id]="'date2'" [model]="newprest.dateMaxStart" (changefct)="newprest.dateMaxStart = $event;"
                        [placeholder]="'Date Max'"
                        (keyenterfct)="common.changeDate($event, newprest.dateMaxStart, '#h1');"
                        (selectfct)="selectDate($event, '#date1')" [showDatepicker]="true">
                      </app-input-date>
                    </div>
                  </ng-template>
                  <div class="form-group col-sm-12" [ngClass]="{'disabledbutton': isMouvPraxy || isEcoDDS}"
                    style="padding: 0; margin-bottom: 15px;">
                    <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
                      [(ngModel)]="newprest.auPlusTard">
                    <span (click)="newprest.auPlusTard = !newprest.auPlusTard;" style="cursor: pointer;">
                      Au + Tard </span>
                  </div>
                  <span class="col-sm-12" style="padding: 0"> Heure : </span>
                  <div class="col-sm-12 form-group" style="padding: 0">
                    <input type="text" class="col-sm-12 inputtime" id="h1" placeholder="Heure"
                      [(ngModel)]="newprest.hour" (keydown.enter)=" showDate = true; common.focusElement('#h2');"
                      autocomplete="off">
                  </div>
                  <span class="col-sm-12" style="padding: 0"> Durée(H) : </span>
                  <div class="col-sm-12" style="padding: 0" [ngClass]="{'disabledbutton': isMouvPraxy}">
                    <input type="text" class="col-sm-5 inputtime" id="h2" placeholder="HH"
                      [(ngModel)]="newprest.hourDuree" [onReturn] autocomplete="off">

                    <input type="text" class="inputtime col-sm-5 col-sm-offset-2" placeholder="MM"
                      [(ngModel)]="newprest.minDuree" autocomplete="off"
                      (keydown.enter)=" showDate = true; setValue(true, 'showdate')">


                  </div>
                </div>
              </div>
              <div class="form-group col-sm-12" id="checkPrestprogram" style="padding: 0; margin-bottom: 15px;"
                [ngClass]="{'disabledbutton': isMouvPraxy || newprest.tournee}">
                <mat-checkbox [color]="'primary'" [(ngModel)]="newprest.program" (ngModelChange)="changeProgram()"
                  [disabled]="isMouvPraxy">
                  <label>Prestation programmée </label>
                </mat-checkbox>

              </div>
              <label *ngIf="newprest.program" class="text" style="padding-left: 0px;"
                [ngClass]="{'disabledbutton': isMouvPraxy || newprest.tournee}" (click)="showProgrammation()">
                <span class='text-underline uppercase'> Définir les paramètres </span></label>

              <div class="uppercase col-sm-12" style="margin: 80px 0px 0px;padding: 0;">
                <button class="btn-ok" id="okChoixDate" (click)="setValue(true, 'showdate'); showDate = true;">
                  OK
                </button>
                <label>Appuyez sur
                  <b>Entrée</b> pour valider.</label>
              </div>
            </div>

            <div *ngSwitchCase="7" class="etape2">
              <div style="margin-bottom: 15px">
                <span class="step-title">Demande </span>
              </div>
              <div class="form-group col-sm-12" style="padding: 0;"
                [ngClass]="{'disabledbutton': !edit && isMouvPraxy}">
                <div>
                  <span>Demande faite par :</span>
                  <app-autocomplete [placeholder]="'Demande faite par'"
                    (selectfunction)="newprest.typeDemande = $event; defaultChoixDmdFaitPar = $event;" [results]="listeChoixDmdFaitPar"
                    [highlight]="true" [label]="" [dropdownclass]="mindropdown" [selectvalue]="true" [isCombo]="true"
                    [id]="'DmdFaitPar'" [defaultselected]="defaultChoixDmdFaitPar"
                    [defaultsearch]="defaultChoixDmdFaitPar ? defaultChoixDmdFaitPar.libelle || defaultChoixDmdFaitPar.libelleObjetEntite:''"></app-autocomplete>
                </div>
              </div>

              <div style="margin-bottom: 15px">
                <span class="step-title">Choix du site </span>
              </div>
              <div class="form-group col-sm-12" style="padding: 0;"
                [ngClass]="{'disabledbutton': !edit && isMouvPraxy}">
                <div>
                  <span>Site de prestation :</span>
                  <app-autocomplete [placeholder]="'Site de prestation'"
                    (searchfunction)="objectFocus.site = true; searchSite($event)" (selectfunction)="newprest.sitePrest = $event; defaultSite = $event;
                     newprest.showsite = true;common.clickElement('.siteCA')" [results]="listeSiteCA"
                    [highlight]="true" [label]="" [dropdownclass]="mindropdown" [selectvalue]="true" [isCombo]="true"
                    [id]="'sitePrest'" [defaultselected]="defaultSite"
                    [defaultsearch]="defaultSite ? defaultSite.nom : ''"></app-autocomplete>
                </div>
              </div>

              <div class="form-group col-sm-12" style="padding: 0;"
                [ngClass]="{'disabledbutton': !edit && isMouvPraxy}">
                <div>
                  <span>Pour le compte de :</span>
                  <app-autocomplete [placeholder]="'Pour le compte de'"
                    (searchfunction)="objectFocus.site = true; searchSite($event)"
                    (selectfunction)="setValue($event, 'siteCA'); defaultSiteCA = $event;" [results]="listeSiteCA"
                    [highlight]="true" [label]="" [dropdownclass]="mindropdown" [selectvalue]="true" [isCombo]="true"
                    [id]="'siteCA'" [defaultselected]="defaultSiteCA"
                    [defaultsearch]="defaultSiteCA ? defaultSiteCA.nom : ''"></app-autocomplete>
                </div>
              </div>

              <div class="uppercase col-sm-12" style="margin: 185px 0px 0px;padding: 0;"
                [ngStyle]="{'margin-top': objectFocus.site ? '185px' : '80px' }">
                <button class="btn-ok" id="okChoixSite"
                  (click)="setValue(defaultSite, 'sitePrest');newprest.siteCA = defaultSiteCA; newprest.showsite = true;">
                  OK
                </button>
                <label>Appuyez sur
                  <b>Entrée</b> pour valider.</label>
              </div>
            </div>
            <div *ngSwitchCase="8" class="etape8" style="height: 100%;">
              <div style="margin-bottom: 15px">
                <span class="step-title"> Divers </span>
              </div>
              <div class="divers" style="overflow-y: auto;height: auto;     max-height: calc(100% - 110px);
              padding-right: 10px;" [ngClass]="{'disabledbutton': !edit && isMouvPraxy}">
                <div class="form-group" style="position: relative;">
                  <label class="labelacompte" *ngIf="newprest.acomptefocus || newprest.acompte"> Acompte </label>
                  <input type="number" step="0.01" class="form-control info" id="acompte" placeholder="Acompte"
                    autofocus [(ngModel)]="newprest.acompte" (keyup.enter)="common.focusNext('.divers')"
                    [ngClass]="{'noValue': !newprest.acomptefocus && !newprest.acompte}"
                    (focus)="newprest.acomptefocus = true;" (blur)="newprest.acomptefocus = false;" autocomplete="off">
                </div>
                <div class="form-group" *ngIf="showContrat" style="position: relative;">
                  <label *ngIf="newprest.contratfocus || newprest.numContrat"> Référence Contrat
                  </label>
                  <input type="text" class="form-control info" placeholder="Contrat" id="contrat"
                    [(ngModel)]="newprest.numContrat" (keyup.enter)="common.focusNext('.divers')"
                    [ngClass]="{'noValue': !newprest.contratfocus && !newprest.numContrat}"
                    (focus)="newprest.contratfocus = true;" (blur)="newprest.contratfocus = false;" autocomplete="off"
                    [disabled]="disableNumContrat()">
                </div>
                <div class="form-group" *ngIf="societe.ecogrc">
                  <app-autocomplete [placeholder]="'Contrat'"
                    (searchfunction)="getListComboContrat();objectFocus.contrat = true;"
                    (selectfunction)="newprest.contratChamp=$event;getListComboPresta();" [results]="listContrat"
                    [highlight]="true" [label]="'Contrat'" [dropdownclass]="mindropdown" [selectvalue]="true"
                    [showonclick]="true" [container]="true" [isCombo]="true" [id]="'contratChamp'"
                    [defaultselected]="newprest.contratChamp"
                    [defaultsearch]="newprest.contratChamp ? (newprest.contratChamp.libelleObjetEntite || newprest.contratChamp.libelle || '') : ''">
                  </app-autocomplete>
                </div>
                <div class="form-group" *ngIf="societe.ecogrc">
                  <app-autocomplete [placeholder]="'Prestation'"
                    (searchfunction)="getListComboPresta();objectFocus.prestation = true;"
                    (selectfunction)="newprest.prestation=$event;" [results]="listPrestation" [highlight]="true"
                    [label]="'Prestation'" [dropdownclass]="mindropdown" [selectvalue]="true" [container]="true"
                    [showonclick]="true" [isCombo]="true" [id]="'prestationChamp'"
                    [defaultselected]="newprest.prestation"
                    [defaultsearch]="newprest.prestation ? (newprest.prestation.libelleObjetEntite || newprest.prestation.libelle || '') : ''">
                  </app-autocomplete>
                </div>
                <div class="form-group" style="position: relative;">
                  <label *ngIf="newprest.numBonfocus || newprest.numBonManuel"> N° de Bon manuel
                  </label>
                  <input type="text" class="form-control info" id="numbon" placeholder="N° de Bon manuel" autofocus
                    [(ngModel)]="newprest.numBonManuel" (keyup.enter)="common.focusNext('.divers')"
                    [ngClass]="{'noValue': !newprest.numBonfocus && !newprest.numBonManuel}"
                    (focus)="newprest.numBonfocus = true;" (blur)="newprest.numBonfocus = false;" autocomplete="off">
                </div>
                <div class="form-group" style="position: relative;">
                  <label *ngIf="newprest.numBSDDfocus || newprest.numBSDD"> N° de BSD manuel
                  </label>
                  <input type="text" class="form-control info" placeholder="N° de BSD manuel" id="numbsdd"
                    [(ngModel)]="newprest.numBSDD" (keyup.enter)="setValue(true, 'divers')"
                    [ngClass]="{'noValue': !newprest.numBSDDfocus && !newprest.numBSDD}"
                    (focus)="newprest.numBSDDfocus = true;" (blur)="newprest.numBSDDfocus = false;" autocomplete="off">
                </div>
                <ng-template [ngIf]="isAmiante && !isGroupe">
                  <div class="form-group col-sm-12 p-0" style="position: relative;">
                    <label *ngIf="newprest.numScellefocus || newprest.numScelle" style="position: absolute;
                    font-size: 11px;
                    text-align: left;
                    color: rgba(55, 97, 148, 0.6);
                    padding: 4px 8px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    font-weight: 700;"> Num Scellé
                    </label>
                    <input type="text" class="form-control info" placeholder="Num Scellé" id="numScelle"
                      [(ngModel)]="newprest.numScelle" (keyup.enter)="setValue(true, 'divers')"
                      [ngClass]="{'noValue': !newprest.numScellefocus && (!newprest.numScelle || newprest.numScelle === '')}"
                      (focus)="newprest.numScellefocus = true;" (blur)="newprest.numScellefocus = false;"
                      autocomplete="off">
                  </div>
                </ng-template>
                <div *ngIf="isChoixCamionCreationMouv" class="form-group">
                  <app-autocomplete [placeholder]="'periode'" (searchfunction)="objectFocus.periode = true;"
                    (selectfunction)="newprest.periode=$event; defaultPeriode = $event" [results]="listPeriode"
                    [highlight]="true" [label]="'Période'" [dropdownclass]="mindropdown" [selectvalue]="true"
                    [isCombo]="true" [container]="true" [id]="'periode'" [defaultselected]="defaultPeriode"
                    [defaultsearch]="defaultPeriode ? (defaultPeriode.libelleObjetEntite || defaultPeriode.libelle) : ''">
                  </app-autocomplete>
                </div>
                <div *ngIf="isChoixCamionCreationMouv" class="form-group">
                  <app-autocomplete [placeholder]="'Camion'" id="exugrp_cam" [selectvalue]="true"
                    (searchfunction)="objectFocus.camion = true;searchListCamion($event)"
                    (selectfunction)="newprest.camion=$event; defaultCamion = $event" [container]="true"
                    [results]="listCamion" [label]="'Camion'" [defaultselected]="defaultCamion"
                    [defaultsearch]="getTextCamion(defaultCamion)">
                  </app-autocomplete>
                </div>
                <div class="form-group col-sm-12" id="checkEquip" style="padding: 0; margin-bottom: 15px;"
                  *ngIf="societe.ecobennesEquipe">
                  <div class="col-sm-6" style="padding: 0;">
                    <mat-checkbox [color]="'primary'" [(ngModel)]="newprest.modeEquipe">
                      Equipe
                    </mat-checkbox>
                  </div>
                  <label *ngIf="newprest.modeEquipe" id="btnshowEquipe" class="col-sm-6 text text-right"
                    style="padding-left: 0px;" (click)="showEquipe()">
                    <span class='text-underline uppercase'> Définir l'équipe </span></label>
                </div>
              </div>

              <div class="uppercase col-sm-12 click-ok" style="margin: 10px 0px 0px;padding: 0;">
                <button class="btn-ok" id="okDivers" (click)="setValue(true, 'divers')">
                  OK
                </button>
                <label>Appuyez sur
                  <b>Entrée</b> pour valider.</label>
              </div>
            </div>
            <div *ngSwitchCase="9" class="etape8">
              <div style="margin-bottom: 15px">
                <span class="step-title" *ngIf="!newprest.showInfos"> Souhaitez vous ajouter des
                  informations supplémentaires </span>
                <span class="step-title" *ngIf="newprest.showInfos"> Informations supplémentaires
                </span>
              </div>
              <div class="list-group" *ngIf="!newprest.showInfos">
                <a class="list-group-item container" tabindex="0" (keyup)="changeFocus($event, i)"
                  (click)="edit ? showLeft = !showLeft : generatePrestation();"
                  (keyup.enter)="edit || isModifierLeContenant ? setValue('test', 'infosSupplementaire') : generatePrestation();">
                  <input type="radio" id="s-option" name="showInfo" value="false"
                    [checked]="newprest.showInfo === false">
                  <span class="text">NON</span>

                </a>
                <a class="list-group-item container" tabindex="1" (keyup)="changeFocus($event, i)"
                  (keyup.enter)="showInfoSupp(true)" (click)="showInfoSupp(true)">
                  <input type="radio" id="s-option" name="showInfo" value="true" [checked]="newprest.showInfo === true">
                  <span class="text">OUI</span>

                </a>
              </div>
              <div *ngIf="newprest.showInfos" [ngClass]="{'disabledbutton': !edit && isMouvPraxy}">
                <div class="form-group">
                  <label *ngIf="newprest.infofactfocus || newprest.infoFact"> Infos fact </label>
                  <input type="text" class="form-control info" id="autofocus" placeholder="Infos Fact" autofocus
                    [(ngModel)]="newprest.infoFact" (keyup.enter)="common.focusElement('#infomvt')"
                    (focus)="newprest.infofactfocus = true;" (blur)="newprest.infofactfocus = false;"
                    autocomplete="off">
                </div>
                <div class="form-group">
                  <label *ngIf="newprest.infomvtfocus || newprest.infoNextMouv"> Infos prestation
                  </label>
                  <input type="text" class="form-control info" placeholder="Infos prestation" id="infomvt"
                    [(ngModel)]="newprest.infoNextMouv" (keyup.enter)="common.focusElement('#infosup')"
                    (focus)="newprest.infomvtfocus = true;" (blur)="newprest.infomvtfocus = false;" autocomplete="off">
                </div>
                <div class="form-group" id="checkPrestImportant" [ngClass]="{'disabledbutton': !edit && isMouvPraxy}"
                  style="padding: 0; margin-bottom: 15px;">
                  <mat-checkbox [color]="'primary'" [(ngModel)]="newprest.isImportant">
                    <label style="position: relative;">Prestation importante</label>
                  </mat-checkbox>
                </div>
                <div class="form-group" [ngClass]="{'disabledbutton': isMouvPraxy}">
                  <label *ngIf="newprest.infosuppfocus || newprest.infos"> Infos contenant </label>
                  <textarea class="form-control" rows="{{countRowsInText(newprest.infos)}}" id="infosup"
                    placeholder="Infos contenant" [(ngModel)]="newprest.infos" style="height: auto;"
                    (focus)="newprest.infosuppfocus = true;" (blur)="newprest.infosuppfocus = false;"
                    autocomplete="off"></textarea>
                  <div class="uppercase" style="font-size: 11px; margin-top: 3px;" *ngIf="newprest.infosuppfocus">Taper
                    sur TAB
                    <span class="icontab">&#x21B9;</span> pour valider
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="uppercase col-sm-12" style="margin: 80px 0px 2px 1px;">
                  <button class="btn-ok" id="okinfoSup"
                    (click)="edit || isModifierLeContenant  ? setValue('test', 'infosSupplementaire') : generatePrestation();"
                    [disabled]="isClicked">
                    OK
                  </button>
                  <label> Appuyez sur
                    <b> Entrée </b> pour valider. </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="add-prestation" *ngIf="isModifierLeContenant && !afficherAutreStep && !modifContenantGrp">
          <div class="etape3 choixContenant" style="height:100%">
            <div style="margin-bottom: 15px">
              <span class="step-title" *ngIf="!addArticle"> Modification du
                contenant </span>
              <span class="step-title" *ngIf="addArticle"> Groupe d'article </span>
            </div>
            <div class="col-sm-12" *ngIf="!addArticle" style="height: calc(100% - 95px); overflow-y: auto;padding: 0;">

              <div *ngIf="newprest.contenant" class="col-sm-12 p-0">
                <div class="form-group">
                  <app-autocomplete
                    (selectfunction)="newprest.contenant.typeContenant = $event;  common.focusElement('.articleCont');  actualiseCont(newprest.contenant) "
                    [results]="typeContenant" [highlight]="true" [showonclick]="true"
                    (searchfunction)="searchTypecontenantByLibelle($event)" [label]="'Type contenant'"
                    id="typecontenant" [placeholder]="'Type contenant'" [container]="true"
                    (keyenterfunction)="common.focusElement('.articleCont')"
                    [defaultselected]="newprest.contenant.typeContenant"
                    [defaultsearch]="newprest.contenant.typeContenant ? newprest.contenant.typeContenant.libelleObjetEntite : ''">
                  </app-autocomplete>
                </div>
                <div class="form-group" *ngIf="!newprest.contenant.isGroupeArticle">
                  <app-autocomplete [placeholder]="'Article'" id="articleCont" (searchfunction)="searchArticle($event)"
                    (selectfunction)="newprest.contenant.art = $event; focustimeOut('.articleCont'); actualiseArt(newprest.contenant.art, newprest.contenant);"
                    [results]="listArticle" [label]="'Article'" [container]="true" (keyenterfunction)="newprest.contenant.art ?  (newprest.contenant && newprest.contenant.typeContenant && !newprest.contenant.typeContenant.isUnitaire ?
                                         common.focusElement('.qteContenant') : saveModifContenant())  : false"
                    [defaultselected]="newprest.contenant.art"
                    [defaultsearch]="newprest.contenant.art ? newprest.contenant.art.libelleObjetEntite : ''">
                  </app-autocomplete>
                </div>


                <div class="form-group"
                  *ngIf="newprest.contenant && newprest.contenant.typeContenant && !newprest.contenant.typeContenant.isUnitaire">
                  <app-autocomplete [placeholder]="'Quantité contenant'" [id]="'listQteId'"
                    (selectfunction)="qteSelected = $event; setValueQte()" [isCombo]="true" [results]="listQte"
                    [label]="'Quantité contenant'" [defaultselected]="qteSelected"
                    [defaultsearch]="qteSelected ? qteSelected.libelleObjetEntite : ''"
                    (keyenterfunction)="setValueQte()">
                  </app-autocomplete>
                </div>
                <!-- <div class="form-group" *ngIf="societe.qtePrevisionnelle && !newprest.contenant.isGroupeArticle">
                  <label *ngIf="newprest.contenant.qte || newprest.contenant.qtefocus" style="position: absolute">
                    Qté Prev </label>
                  <input type="number" step="1" class="form-control info" id="qte" placeholder="Qté Prev" autofocus
                    [(ngModel)]="newprest.contenant.qte" (focus)="newprest.contenant.qtefocus = true;"
                    (blur)="newprest.contenant.qtefocus = false;"
                    autocomplete="off">
                </div> -->
                <div class="form-group" *ngIf="societe.axeAnalytiqueLigneBon">
                  <label *ngIf="newprest.contenant.axeAnalytiqueLigne || newprest.contenant.axeAnalytiqueLignefocus"
                    style="position: absolute">
                    Axe ana. Prest </label>
                  <input type="text" class="form-control info" id="axeAnalytiqueLigne" placeholder="Axe ana. Prest"
                    autofocus [(ngModel)]="newprest.contenant.axeAnalytiqueLigne"
                    (focus)="newprest.contenant.axeAnalytiqueLignefocus = true;"
                    (blur)="newprest.contenant.axeAnalytiqueLignefocus = false;" autocomplete="off">
                </div>

                <div class="form-group" *ngIf="societe.groupeArticleEcobennes">
                  <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
                    [(ngModel)]="newprest.contenant.isGroupeArticle" (ngModelChange)="newprest.contenant.art = {}">
                  <span (click)="newprest.contenant.isGroupeArticle = !newprest.contenant.isGroupeArticle"
                    style="cursor: pointer;">
                    Groupe </span>
                  <label class="text pull-right" *ngIf="newprest.contenant.isGroupeArticle"
                    style=" margin: 0px;padding: 0px;" (click)="showArticleGrp(); addArticlesContenant()">
                    <span class='text-underline uppercase'> ajouter un article
                    </span></label>
                </div>


                <div class="list-group" *ngIf="newprest.contenant.isGroupeArticle" style="margin-bottom: 15px;">
                  <li class="list-group-item container" id="autofocus" style="height: auto; padding: 5px 2px;"
                    *ngFor="let item of newprest.contenant.listArticle; let i = index;" tabindex="{{i}}">

                    <div class="col-sm-10" style="padding: 0px 4px 0;">
                      <div>
                        {{societe.qtePrevisionnelle ? item.qte || '' : ''}}
                        {{item.art ? (item.art.code) : ''}} / {{item.art ? (item.art.libelleObjetEntite ||
                        item.art.libelle) : ''}}
                      </div>
                      <div>
                        {{item.exutoire ? (item.exutoire.libelleObjetEntite ||
                        item.exutoire.nom) : ''}}
                      </div>
                    </div>
                    <div class="col-sm-2 text-center" style="padding: 0px">
                      <button class="btn-detail" style="margin: 0px 1px;"
                        (click)="selactedArticle = item; showArticleGrp();">
                        <i class="fa fa-pencil"></i>
                      </button>
                      <button class="btn-detail" style="margin: 0px 1px;"
                        (click)="deleteListArticles(newprest.contenant.listArticle, item)">
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>

                  </li>
                </div>
                <div class="form-group" *ngIf="societe.axeAnalytiqueLigneBon && !newprest.contenant.isGroupeArticle">
                  <label
                    *ngIf="newprest.contenant.axeAnalytiqueLigneArt || newprest.contenant.axeAnalytiqueLigneArtfocus"
                    style="position: absolute">
                    Axe ana. Art </label>
                  <input type="text" class="form-control info" id="axeAnalytiqueLigneArt" placeholder="Axe ana. Art"
                    autofocus [(ngModel)]="newprest.contenant.axeAnalytiqueLigneArt"
                    (focus)="newprest.contenant.axeAnalytiqueLigneArtfocus = true;"
                    [ngClass]="{'noValue': !newprest.contenant.axeAnalytiqueLigneArt && !newprest.contenant.axeAnalytiqueLigneArtfocus}"
                    (blur)="newprest.contenant.axeAnalytiqueLignefocus = false;" autocomplete="off">
                </div>
                <ng-template [ngIf]="societe.gestionBenneClient">
                  <div class="form-group">
                    <mat-checkbox [color]="'primary'" [(ngModel)]="newprest.contenant.benneClient"
                      (ngModelChange)="newprest.contenant.mailContenant = ''">
                      <label>Appartient au client </label>
                    </mat-checkbox>
                  </div>
                </ng-template>
                <div class="form-group" *ngIf="societe.mailBenneChantiers">
                  <label *ngIf="newprest.contenant.mailContenant || newprest.mailContenantfocus"
                    style="position: absolute">
                    Mail </label>
                  <input type="text" class="form-control info" id="mailContenant" placeholder="Mail" autofocus
                    [(ngModel)]="newprest.contenant.mailContenant" (keyup.enter)="setValue('test', 'cont')"
                    (focus)="newprest.mailContenantfocus = true;" (blur)="newprest.mailContenantfocus = false;"
                    [ngStyle]="{'padding':  (newprest.contenant.mailContenant || newprest.mailContenantfocus) ? 'padding: 16px 10px 0 10px' : '0 10px'}"
                    [disabled]="!newprest.contenant.benneClient" autocomplete="off">
                </div>
                <div class="form-group col-sm-6" style="padding: 0; margin-top: 15px;">
                  <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
                    [(ngModel)]="newprest.contenant.isLocation" [disabled]="isVidage">
                  <span (click)="newprest.contenant.isLocation = !newprest.contenant.isLocation"
                    style="cursor: pointer;">
                    Location </span>
                </div>
                <div class="form-group col-sm-6">

                  <app-input-date [container]="true" [closeDatepickerOnSelect]="true" [class]="'col-sm-12 date'"
                    [id]="'date'" [model]="newprest.contenant.dateDebutLoc"
                    (changefct)="newprest.contenant.dateDebutLoc = $event;" [placeholder]="'Date debut'"
                    [activeNavigate]="true"
                    (keyenterfct)="changeDatePlanning('dateDebutLoc', 'contenant');common.changeDate($event, newprest.contenant.dateDebutLoc); saveModifContenant()"
                    (selectfct)="selectDate($event, '#date')" [disable]="!newprest.contenant.isLocation || isVidage"
                    [position]="'bottom-right'" [showDatepicker]="true">
                  </app-input-date>
                </div>
                <div class="form-group col-sm-12" *ngIf="newprest.contenant.isLocation"
                  style="padding: 0; margin: 0 0 15px;">
                  <label class="text" style=" margin: 0;padding-left: 0px;" (click)="showFacturation()">
                    <span class='text-underline uppercase'> Facturation </span></label>
                </div>
                <div class="form-group items col-sm-12" id="conteneurLieu" style="padding: 0">
                  <app-autocomplete (searchfunction)="objectFocus.lieu = true; searchZone($event)"
                    [results]="resultZone" [highlight]="true"
                    [placeholder]="societe.clientCollectivite ? 'Circuit' : 'Lieu'"
                    [label]="societe.clientCollectivite ? 'Circuit' : 'Lieu'" [isCombo]="true" [disablefocus]="true"
                    [id]="'idLieu'" [notLoading]="true" [defaultselected]="newprest.lieu"
                    [defaultsearch]="newprest.lieu ? newprest.lieu.libelleObjetEntite || '' : ''"
                    (selectfunction)="objectFocus.lieu = false;newprest.lieu = $event;">
                  </app-autocomplete>
                </div>
              </div>
            </div>

            <div *ngIf="addArticle" style="height: calc(100% - 45px); overflow-y: auto;">
              <div class="col-sm-12" style="padding: 0;">
                <div class="form-group">
                  <app-autocomplete [placeholder]="'Article'" id="articlegrp"
                    (searchfunction)="searchArticle($event, newBenne.listArticle)"
                    (selectfunction)="selactedArticle.art = $event;  actualiseArt(selactedArticle.art, selactedArticle);"
                    [results]="listArticle" [label]="'Article'" [defaultselected]="selactedArticle.art"
                    [container]="true"
                    (keyenterfunction)="selactedArticle.art && selactedArticle.art.id ? common.focusElement('.exugrp') : false"
                    [defaultsearch]="selactedArticle.art ? (selactedArticle.art.libelleObjetEntite || selactedArticle.art.libelle) : ''">

                  </app-autocomplete>
                </div>
                <div class="form-group">
                  <app-autocomplete [placeholder]="'Exutoire'" id="exugrp" (searchfunction)="searchExutoire($event)"
                    (selectfunction)="selactedArticle.exutoire = $event;" [results]="listExutoire" [label]="'Exutoire'"
                    [container]="true" [defaultselected]="selactedArticle.exutoire"
                    (keyenterfunction)="selactedArticle.art && selactedArticle.art.id ? showArticleGrp() : common.focusElement('.articlegrp')"
                    [defaultsearch]="selactedArticle.exutoire ? (selactedArticle.exutoire.libelleObjetEntite || selactedArticle.exutoire.nom) : ''">
                  </app-autocomplete>
                </div>
                <div class="form-group" *ngIf="societe.qtePrevisionnelle">
                  <label *ngIf="selactedArticle.qte || selactedArticle.qtefocus" style="position: absolute">
                    Qté Prev </label>
                  <input type="number" step="1" class="form-control info" id="qte" placeholder="Qté Prev" autofocus
                    [(ngModel)]="selactedArticle.qte" (focus)="selactedArticle.qtefocus = true;"
                    (blur)="selactedArticle.qtefocus = false;"
                    (keyup.enter)="selactedArticle.art && selactedArticle.art.id ? showArticleGrp() : common.focusElement('.articlegrp')"
                    autocomplete="off">
                </div>
                <div class="form-group" *ngIf="societe.axeAnalytiqueLigneBon">
                  <label *ngIf="selactedArticle.axeAnalytiqueLigneArt || selactedArticle.axeAnalytiqueLigneArtfocus"
                    style="position: absolute">
                    Axe ana. Art </label>
                  <input type="text" class="form-control info" id="axeAnalytiqueLigneArt" placeholder="Axe ana. Art"
                    autofocus [(ngModel)]="selactedArticle.axeAnalytiqueLigneArt"
                    (focus)="selactedArticle.axeAnalytiqueLigneArtfocus = true;"
                    [ngClass]="{'noValue': !selactedArticle.axeAnalytiqueLigneArt && !selactedArticle.axeAnalytiqueLigneArtfocus}"
                    (keyup.enter)="selactedArticle.art && selactedArticle.art.id ? showArticleGrp() : common.focusElement('.articlegrp')"
                    (blur)="selactedArticle.axeAnalytiqueLignefocus = false;" autocomplete="off">
                </div>
              </div>


              <div class="uppercase" style="margin: 10px 0px;">
                <button class="btn-ok" id="okifaddArt"
                  (click)="selactedArticle.art && selactedArticle.art.id ? showArticleGrp() : common.focusElement('.articlegrp');">
                  OK
                </button>
                <label>Appuyez sur
                  <b>Entrée</b> pour valider.</label>
              </div>
            </div>

            <div class="uppercase" *ngIf="!addArticle" style="margin: 80px 0px;">
              <button class="btn-ok" id="oksaveModifContenant" (click)="saveModifContenant()">
                OK
              </button>
              <label>Appuyez sur
                <b>Entrée</b> pour valider.</label>
            </div>
          </div>
        </div>
        <div class="add-prestation" *ngIf="!isModifierLeContenant && !afficherAutreStep && modifContenantGrp">
          <div class="etape3 choixContenant" style="height:100%">
            <div style="margin-bottom: 15px">
              <span class="step-title" *ngIf="!addArticle"> Modification du
                contenant </span>
              <span class="step-title" *ngIf="addArticle"> Groupe d'article </span>
            </div>
            <div class="col-sm-12" *ngIf="!addArticle" style="height: calc(100% - 95px); overflow-y: auto;padding: 0;">

              <div *ngIf="selectedContenantGrp" class="col-sm-12 p-0">
                <div class="form-group">
                  <app-autocomplete
                    (selectfunction)="selectedContenantGrp.typeContenant = $event;  common.focusElement('.articleCont');  actualiseCont(selectedContenantGrp) "
                    [results]="typeContenant" [highlight]="true" [showonclick]="true"
                    (searchfunction)="searchTypecontenantByLibelle($event)" [label]="'Type contenant'"
                    id="typecontenant" [placeholder]="'Type contenant'" [container]="true"
                    (keyenterfunction)="common.focusElement('.articleCont')"
                    [defaultselected]="selectedContenantGrp.typeContenant"
                    [defaultsearch]="selectedContenantGrp.typeContenant ? selectedContenantGrp.typeContenant.libelleObjetEntite : ''">
                  </app-autocomplete>
                </div>
                <div class="form-group" *ngIf="!selectedContenantGrp.isGroupeArticle">
                  <app-autocomplete [placeholder]="'Article'" id="articleCont" (searchfunction)="searchArticle($event)"
                    (selectfunction)="selectedContenantGrp.art = $event; focustimeOut('.articleCont'); actualiseArt(selectedContenantGrp.art, selectedContenantGrp);"
                    [results]="listArticle" [label]="'Article'" [container]="true" (keyenterfunction)="selectedContenantGrp.art ?  (selectedContenantGrp && selectedContenantGrp.typeContenant && !selectedContenantGrp.typeContenant.isUnitaire ?
                                         common.focusElement('.qteContenant') : saveModifContenant())  : false"
                    [defaultselected]="selectedContenantGrp.art"
                    [defaultsearch]="selectedContenantGrp.art ? selectedContenantGrp.art.libelleObjetEntite : ''">
                  </app-autocomplete>
                </div>


                <!-- <div class="form-group"
                  *ngIf="selectedContenantGrp && selectedContenantGrp.typeContenant && !selectedContenantGrp.typeContenant.isUnitaire">
                  <app-autocomplete [placeholder]="'Quantité contenant'" [id]="'listQteId'"
                    (selectfunction)="qteSelected = $event; setValueQte()" [isCombo]="true" [results]="listQte"
                    [label]="'Quantité contenant'" [defaultselected]="qteSelected"
                    [defaultsearch]="qteSelected ? qteSelected.libelleObjetEntite : ''"
                    (keyenterfunction)="setValueQte()">
                  </app-autocomplete>
                </div> -->
                <!-- <div class="form-group" *ngIf="societe.qtePrevisionnelle && !selectedContenantGrp.isGroupeArticle">
                  <label *ngIf="selectedContenantGrp.qte || selectedContenantGrp.qtefocus" style="position: absolute">
                    Qté Prev </label>
                  <input type="number" step="1" class="form-control info" id="qte" placeholder="Qté Prev" autofocus
                    [(ngModel)]="selectedContenantGrp.qte" (focus)="selectedContenantGrp.qtefocus = true;"
                    (blur)="selectedContenantGrp.qtefocus = false;"
                    autocomplete="off">
                </div> -->
                <!-- <div class="form-group" *ngIf="societe.axeAnalytiqueLigneBon">
                  <label *ngIf="selectedContenantGrp.axeAnalytiqueLigne || selectedContenantGrp.axeAnalytiqueLignefocus"
                    style="position: absolute">
                    Axe ana. Prest </label>
                  <input type="text" class="form-control info" id="axeAnalytiqueLigne" placeholder="Axe ana. Prest"
                    autofocus [(ngModel)]="selectedContenantGrp.axeAnalytiqueLigne"
                    (focus)="selectedContenantGrp.axeAnalytiqueLignefocus = true;"
                    (blur)="selectedContenantGrp.axeAnalytiqueLignefocus = false;" autocomplete="off">
                </div> -->

                <div class="form-group" *ngIf="societe.groupeArticleEcobennes">
                  <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
                    [(ngModel)]="selectedContenantGrp.isGroupeArticle" (ngModelChange)="selectedContenantGrp.art = {}">
                  <span (click)="selectedContenantGrp.isGroupeArticle = !selectedContenantGrp.isGroupeArticle"
                    style="cursor: pointer;">
                    Groupe </span>
                  <label class="text pull-right" *ngIf="selectedContenantGrp.isGroupeArticle"
                    style=" margin: 0px;padding: 0px;" (click)="showArticleGrp(); addArticlesContenantGrp()">
                    <span class='text-underline uppercase'> ajouter un article
                    </span></label>
                </div>


                <div class="list-group" *ngIf="selectedContenantGrp.isGroupeArticle" style="margin-bottom: 15px;">
                  <li class="list-group-item container" id="autofocus" style="height: auto; padding: 5px 2px;"
                    *ngFor="let item of selectedContenantGrp.listArticle; let i = index;" tabindex="{{i}}">

                    <div class="col-sm-10" style="padding: 0px 4px 0;">
                      <div>
                        {{societe.qtePrevisionnelle ? item.qte || '' : ''}}
                        {{item.art ? (item.art.code) : ''}} / {{item.art ? (item.art.libelleObjetEntite ||
                        item.art.libelle) : ''}}
                      </div>
                      <div>
                        {{item.exutoire ? (item.exutoire.libelleObjetEntite ||
                        item.exutoire.nom) : ''}}
                      </div>
                    </div>
                    <div class="col-sm-2 text-center" style="padding: 0px">
                      <button class="btn-detail" style="margin: 0px 1px;"
                        (click)="selactedArticle = item; showArticleGrp();">
                        <i class="fa fa-pencil"></i>
                      </button>
                      <button class="btn-detail" style="margin: 0px 1px;"
                        (click)="deleteListArticles(selectedContenantGrp.listArticle, item)">
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>

                  </li>
                </div>
                <!-- <div class="form-group" *ngIf="societe.axeAnalytiqueLigneBon && !selectedContenantGrp.isGroupeArticle">
                  <label
                    *ngIf="selectedContenantGrp.axeAnalytiqueLigneArt || selectedContenantGrp.axeAnalytiqueLigneArtfocus"
                    style="position: absolute">
                    Axe ana. Art </label>
                  <input type="text" class="form-control info" id="axeAnalytiqueLigneArt" placeholder="Axe ana. Art"
                    autofocus [(ngModel)]="selectedContenantGrp.axeAnalytiqueLigneArt"
                    (focus)="selectedContenantGrp.axeAnalytiqueLigneArtfocus = true;"
                    [ngClass]="{'noValue': !selectedContenantGrp.axeAnalytiqueLigneArt && !selectedContenantGrp.axeAnalytiqueLigneArtfocus}"
                    (blur)="selectedContenantGrp.axeAnalytiqueLignefocus = false;" autocomplete="off">
                </div> -->
                <ng-template [ngIf]="societe.gestionBenneClient">
                  <div class="form-group">
                    <mat-checkbox [color]="'primary'" [(ngModel)]="selectedContenantGrp.benneClient"
                      (ngModelChange)="selectedContenantGrp.mailContenant = ''">
                      <label>Appartient au client </label>
                    </mat-checkbox>
                  </div>
                </ng-template>
                <!-- <div class="form-group" *ngIf="societe.mailBenneChantiers">
                  <label *ngIf="selectedContenantGrp.mailContenant || selectedContenantGrp.mailContenantfocus"
                    style="position: absolute">
                    Mail </label>
                  <input type="text" class="form-control info" id="mailContenant" placeholder="Mail" autofocus
                    [(ngModel)]="selectedContenantGrp.mailContenant" (keyup.enter)="setValue('test', 'cont')"
                    (focus)="selectedContenantGrp.mailContenantfocus = true;" (blur)="selectedContenantGrp.mailContenantfocus = false;"
                    [ngStyle]="{'padding':  (selectedContenantGrp.mailContenant || selectedContenantGrp.mailContenantfocus) ? 'padding: 16px 10px 0 10px' : '0 10px'}"
                    [disabled]="!selectedContenantGrp.benneClient" autocomplete="off">
                </div> -->
                <div class="form-group col-sm-6" style="padding: 0; margin-top: 15px;">
                  <input type="checkbox" id="checkbox-1-1 " class="regular-checkbox regular-checkbox-checked"
                    [(ngModel)]="selectedContenantGrp.isLocation" [disabled]="isVidage">
                  <span (click)="selectedContenantGrp.isLocation = !selectedContenantGrp.isLocation"
                    style="cursor: pointer;">
                    Location </span>
                </div>
                <div class="form-group col-sm-6">

                  <app-input-date [container]="true" [closeDatepickerOnSelect]="true" [class]="'col-sm-12 date'"
                    [id]="'date'" [model]="selectedContenantGrp.dateDebutLocModel"
                    (changefct)="selectedContenantGrp.dateDebutLocModel = $event;" [placeholder]="'Date debut'"
                    [activeNavigate]="true"
                    (keyenterfct)="changeDatelocContGrp('dateDebutLoc');common.changeDate($event, selectedContenantGrp.dateDebutLocModel); validerModifcontenantGroupe()"
                    (selectfct)="selectDate($event, '#date')" [disable]="!selectedContenantGrp.isLocation || isVidage"
                    [position]="'bottom-right'" [showDatepicker]="true" [dateVide]="true">
                  </app-input-date>
                </div>
                <div class="form-group col-sm-12" *ngIf="selectedContenantGrp.isLocation"
                  style="padding: 0; margin: 0 0 15px;">
                  <label class="text" style=" margin: 0;padding-left: 0px;" (click)="showFacturation()">
                    <span class='text-underline uppercase'> Facturation </span></label>
                </div>

              </div>
            </div>

            <div *ngIf="addArticle" style="height: calc(100% - 45px); overflow-y: auto;">
              <div class="col-sm-12" style="padding: 0;">
                <div class="form-group">
                  <app-autocomplete [placeholder]="'Article'" id="articlegrp"
                    (searchfunction)="searchArticle($event, newBenne.listArticle)"
                    (selectfunction)="selactedArticle.art = $event;  actualiseArt(selactedArticle.art, selactedArticle);"
                    [results]="listArticle" [label]="'Article'" [defaultselected]="selactedArticle.art"
                    [container]="true"
                    (keyenterfunction)="selactedArticle.art && selactedArticle.art.id ? common.focusElement('.exugrp') : false"
                    [defaultsearch]="selactedArticle.art ? (selactedArticle.art.libelleObjetEntite || selactedArticle.art.libelle) : ''">

                  </app-autocomplete>
                </div>
                <div class="form-group">
                  <app-autocomplete [placeholder]="'Exutoire'" id="exugrp" (searchfunction)="searchExutoire($event)"
                    (selectfunction)="selactedArticle.exutoire = $event;" [results]="listExutoire" [label]="'Exutoire'"
                    [container]="true" [defaultselected]="selactedArticle.exutoire"
                    (keyenterfunction)="selactedArticle.art && selactedArticle.art.id ? showArticleGrp() : common.focusElement('.articlegrp')"
                    [defaultsearch]="selactedArticle.exutoire ? (selactedArticle.exutoire.libelleObjetEntite || selactedArticle.exutoire.nom) : ''">
                  </app-autocomplete>
                </div>
                <div class="form-group" *ngIf="societe.qtePrevisionnelle">
                  <label *ngIf="selactedArticle.qte || selactedArticle.qtefocus" style="position: absolute">
                    Qté Prev </label>
                  <input type="number" step="1" class="form-control info" id="qte" placeholder="Qté Prev" autofocus
                    [(ngModel)]="selactedArticle.qte" (focus)="selactedArticle.qtefocus = true;"
                    (blur)="selactedArticle.qtefocus = false;"
                    (keyup.enter)="selactedArticle.art && selactedArticle.art.id ? showArticleGrp() : common.focusElement('.articlegrp')"
                    autocomplete="off">
                </div>
                <!-- <div class="form-group" *ngIf="societe.axeAnalytiqueLigneBon">
                  <label *ngIf="selactedArticle.axeAnalytiqueLigneArt || selactedArticle.axeAnalytiqueLigneArtfocus"
                    style="position: absolute">
                    Axe ana. Art </label>
                  <input type="text" class="form-control info" id="axeAnalytiqueLigneArt" placeholder="Axe ana. Art"
                    autofocus [(ngModel)]="selactedArticle.axeAnalytiqueLigneArt"
                    (focus)="selactedArticle.axeAnalytiqueLigneArtfocus = true;"
                    [ngClass]="{'noValue': !selactedArticle.axeAnalytiqueLigneArt && !selactedArticle.axeAnalytiqueLigneArtfocus}"
                    (keyup.enter)="selactedArticle.art && selactedArticle.art.id ? showArticleGrp() : common.focusElement('.articlegrp')"
                    (blur)="selactedArticle.axeAnalytiqueLignefocus = false;" autocomplete="off">
                </div> -->
              </div>


              <div class="uppercase" style="margin: 10px 0px;">
                <button class="btn-ok" id="okifaddArt"
                  (click)="selactedArticle.art && selactedArticle.art.id ? showArticleGrp() : common.focusElement('.articlegrp');">
                  OK
                </button>
                <label>Appuyez sur
                  <b>Entrée</b> pour valider.</label>
              </div>
            </div>

            <div class="uppercase" *ngIf="!addArticle" style="margin: 80px 0px;">
              <button class="btn-ok" id="validerModifcontenantGroupe" (click)="validerModifcontenantGroupe()">
                OK
              </button>
              <label>Appuyez sur
                <b>Entrée</b> pour valider.</label>
            </div>
          </div>
        </div>
        <div class="text-left uppercase btn-nav" id="btnPrevStep" style="margin-left: -40px;cursor: pointer;"
          *ngIf="!edit && !isModifierLeContenant && step > 1 && !editContenant">
          <span (click)="prevStep()" style="cursor: pointer;">Précédent</span>
        </div>
        <div class="text-left uppercase btn-nav" id="btnNextStep"
          *ngIf="!edit && !isModifierLeContenant && step < 9  && !editContenant"
          style="position: absolute;right: 0px;bottom: 23px;cursor: pointer;">
          <span (click)="nextStep()" style="cursor: pointer;">Suivant</span>
        </div>
      </div>
    </div>
  </div>
  <div id="slide-right">
    <div class="col-sm-12" style="margin-bottom:5px;" [ngStyle]="{'padding': isGroupe ? '0px': '0px 15px'}">
      <!-- <button class="pull-left btn-close" *ngIf="edit" (click)="testerImprimerBon()"> Imprimer </button> -->
      <button class="pull-left btn-close mt-2" id="editcontentRight" *ngIf="showEditBtn && !isGroupe"
        (click)="modifierLeContenant()" style="width: auto;">
        Modifier le contenant
      </button>
      <button class="pull-left btn-close" id="deleteGrp" *ngIf="showDeleteGroupBtn" (click)="supprimerLeGroupe()"
        style="width: auto;">
        Supprimer le groupe
      </button>

      <div dropdown class="pull-left mt-2" style="padding: 0px" *ngIf="edit && !isHisto">
        <button type="submit" dropdownToggle class="pull-left btn-close" style="    width: 117px;">
          ...
        </button>
        <ul *dropdownMenu class="dropdown-menu menuplus" role="menu" style="padding: 5px;">
          <li *ngIf="isDroitImpBon" role="menuitem">
            <button class="bouton btn-simple" *ngIf="edit" (click)="testerImprimerBon()"> IMPRIMER
            </button>
          </li>
          <li role="menuitem" *ngIf="isDroitImpBSD">
            <button class="bouton btn-simple" id="btn-impBSD" *ngIf="edit" (click)="getToutesRsrcBSDDPlanningGeneral()">
              IMPRIMER BSD
            </button>
          </li>

          <li role="menuitem">
            <button class="bouton btn-simple" id="btn-impBSD" *ngIf="edit" (click)="getToutesRsrcDACPlanningGeneral()">
              IMPRIMER DAC
            </button>
          </li>

          <li role="menuitem">
            <button class="bouton btn-simple" id="btn-impADR" (click)="imprimerADR()">
              IMPRIMER ADR
            </button>
          </li>
          <li role="menuitem">
            <button class="bouton btn-simple" id="btn-sendMailChant" *ngIf="edit"
              (click)="dialogueFormatPersoBonParMail()">
              Envoyer par mail au chantier
            </button>
          </li>
          <li role="menuitem">
            <button class="bouton btn-simple uppercase" id="btn-logs" *ngIf="edit && !isHisto"
              (click)="getLogs(newprest)">
              Logs
            </button>
          </li>
          <li role="menuitem">
            <button class="bouton btn-simple uppercase" id="btn-suppression" *ngIf="edit && !isHisto && isDroitSuppMouv"
              (click)='initSupprimerBon()'>
              Supprimer
            </button>
          </li>
        </ul>
      </div>


      <button class="pull-right btn-close btn-valider mt-2" *ngIf="edit && isModifier" id="btnvalider" autofocus
        (click)="openModalConfirme()" (keydown.enter)="openModalConfirme()" [disabled]="isClicked">
        Valider
      </button>
      <button class="pull-right btn-close mt-2" id="closeSlide" (click)="closeFunction()"> Fermer</button>

    </div>
    <div class="col-sm-12">
      <h3 style="padding-left: 10px;font-size: 30px;font-weight: 300;font-family: Roboto-Light;"
        *ngIf="edit || isModifierLeContenant || newprest.showdate">
        {{(newprest.dateStart |
        date:'dd MMMM yyyy') }}</h3>
      <h3 style="padding-left: 13px; font-size: 24px;font-weight: 900;font-family: Roboto-Black;"
        *ngIf="edit && (newprest.listBon && newprest.listBon.length)">
        Bon N° <span *ngFor="let bon of newprest.listBon; let last = last;"> <span
            *ngIf="bon.id === info.bonSelected.id">{{
            !last ? bon.numBon :
            bon.numBon }}</span> </span>
      </h3>
    </div>
    <div class="col-sm-12" style="height: calc(100% - 110px); overflow-y: auto; overflow-x: hidden;">
      <div class="col-sm-12" style="padding: 0">
        <div class="col-sm-6" *ngIf="newprest.client" style="cursor: pointer;">
          <div class="col-sm-12 p-0">
            <label> Client </label>
            <label *ngIf="!isHisto && newprest.client" id="btnShowFicheCli"
              class=" text-left uppercase text-underline showfiche" (click)="showFiche()"
              style="margin-top: 7px;padding-left: 8px;">
              Voir la fiche
            </label>
          </div>

          <div>
            <div class="col-sm-12" style="padding-left: 0px;"> {{ newprest.client.libelleObjetEntite }}
            </div>
          </div>
        </div>
        <div class="col-sm-6 pull-right" [ngClass]="{'div': !isVidage && !edit && !editContenant}"
          *ngIf="newprest.chantier" style="cursor: pointer;">
          <div class="col-sm-12 p-0">
            <label
              (click)="!edit && !editContenant ? editEvent(newprest, 2) : (!editContenant ? editEvent(newprest, 2, '.idLieu') : false)">
              Chantier </label>
            <label *ngIf="!isHisto && newprest.chantier" id="btnShowFicheChant"
              class=" text-left uppercase text-underline showfiche" (click)="getChantier(newprest.chantier.id)"
              style="margin-top: 7px;padding-left: 8px;">
              Voir la fiche
            </label>
          </div>

          <div class="col-sm-12 p-0"
            (click)="!edit && !editContenant ? editEvent(newprest, 2) : (!editContenant ? editEvent(newprest, 2, '.idLieu') : false)">
            <div>{{ newprest.chantier.numChantier }}</div>
            <div class="info2Ligne" style="text-overflow: clip;">{{ newprest.chantier.adresse1 || '' }}</div>
            <div class="info2Ligne" style="text-overflow: clip;">{{ newprest.chantier.codePostal || '' }} {{
              newprest.chantier.ville || '' }}</div>
            <div class="info2Ligne" style="text-overflow: clip;">{{ newprest.chantier.telephone || '' }}</div>
            <!-- <div>{{ newprest.lieu ? (newprest.lieu.libelleObjetEntite || '') : '' }}</div> -->
          </div>

        </div>

      </div>
      <!-- <div class="col-sm-12" style="padding: 0">
        <div class="col-sm-6" *ngIf="!isHisto">
          <label *ngIf="newprest.client" id="btnShowFicheCli" class=" text-left uppercase text-underline showfiche"
            (click)="showFiche()" style="margin-top: 7px;">
            Voir la fiche
          </label>
        </div>
        <div class="col-sm-6" *ngIf="!isHisto">
          <label *ngIf="newprest.chantier" id="btnShowFicheChant" class=" text-left uppercase text-underline showfiche"
            (click)="getChantier(newprest.chantier.id)">
            Voir la fiche
          </label>
        </div>
      </div> -->

      <!-- <div class="col-sm-12"
        [ngClass]="{'div': !isVidage && !edit && !editContenant, 'disabledbutton': isMouvPraxy || isEcoDDS || clientBloquer}"
        *ngIf="newprest.adresse" id="btn-editAdress" (click)="!edit && !editContenant ? editEvent(newprest, 3) : false"
        style="cursor: pointer;">
        <label> Adresse </label>
        <div style="margin-bottom: 5px;">
          {{ ((selectedChantier.numChantier || "") + ' - ' + (selectedChantier.adresse1 || "") + ' - ' +
          (selectedChantier.codePostal
          || "") + ' ' + (selectedChantier.ville || "") + (selectedChantier.telephone ? ' - ' +
          selectedChantier.telephone :
          '')) }}
        </div>
      </div> -->

      <!-- <div class="col-sm-12" id="btn-editLieu"
        [ngClass]="{'div': !isVidage && !editContenant, 'disabledbutton': isMouvPraxy || isEcoDDS || clientBloquer}"
        *ngIf="edit || (newprest.chantier || newprest.lieu)"
        (click)="!editContenant ? editEvent(newprest, 2, '.idLieu') : false" style="cursor: pointer;">
        <label> Lieu </label>
        <div style="margin-bottom: 5px;">
          {{ newprest.lieu ? (newprest.lieu.libelleObjetEntite || '') : '' }}
        </div>
      </div> -->

      <div id="btn-editContTourn" class="col-sm-12  {{ (isVidage && isGroupe) || editContenant ? '' : 'div' }}"
        *ngIf="newprest.contenant && !newprest.tournee"
        (click)="edit ? modifContentContenant()  : editEvent(newprest, 3)" [ngClass]="{'disabledbutton': notEditable}">
        <label> Contenant </label>
        <div style="margin-bottom: 5px;">
          <app-contenant [item]="newprest.contenant" [hide_hovergrp]='true' [hide_contrat]='true'
            [showAllArticle]="true" [showPopOver]='false' [common]="common">
          </app-contenant>
        </div>
      </div>

      <div id="btn-editContNotTourn" class="col-sm-12  {{ (isVidage && isGroupe) || editContenant ? '' : 'div' }}"
        *ngIf="newprest.contenant && newprest.tournee" (click)="edit ? editEvent(newprest, 3)  : editEvent(newprest, 3)"
        [ngClass]="{'disabledbutton': notEditable }">
        <label> Contenant </label>
        <div style="margin-bottom: 5px;">
          <div *ngIf="newprest.tournee">
            <div class="col-sm-1" style="padding: 0; width: 45px;" [ngStyle]="{'color': findCouleur()}">
              <i class="fa fa-undo" aria-hidden="true"
                style="font-size: 1.5em; padding-top: 4px;transform: rotate(145deg);"></i>
            </div>
            <div class="col-sm-11" style="padding: 0 0 0 15px;">
              Tournée
            </div>
          </div>
        </div>
      </div>

      <div id="btn-editNewbenne" class="col-sm-12 {{ editContenant ? '' : 'div' }}"
        *ngIf="newprest.newBenne && !isDmdEcoGED" [ngClass]="{'disabledbutton': notEditable }"
        (click)="edit ? modifContentContenant() : editEvent(newprest, 3)">
        <label> Contenant </label>
        <div style="margin-bottom: 5px;">
          <app-contenant [item]="newprest.newBenne" [hide_hovergrp]='true' [hide_contrat]='true' [showAllArticle]="true"
            [showPopOver]='false' [common]="common"></app-contenant>
        </div>
      </div>

      <div id="btn-editExu"
        class="col-sm-6  {{ (isVidage && isGroupe) || (editContenant && !isModifierLeContenant) ? '' : 'div' }}"
        *ngIf="edit || isModifierLeContenant || newprest.exutoire"
        (click)="editEvent(newprest, (addContenant && !isGroupe ? 5 : 4))" [ngClass]="{'disabledbutton': notEditable}"
        style="    white-space: nowrap;">
        <div class="col-sm-12 p-0 info2Ligne"><label> Exutoire </label>
          <span style="margin-bottom: 5px;">
            {{ newprest.exutoire ? newprest.exutoire.libelleObjetEntite : '' }}
          </span>
        </div>

      </div>
      <div id="btn-editOp" class="col-sm-6"
        [ngClass]="{'div': !isVidage, 'disabledbutton': isVidage || notEditable || isMouvPraxy || isEcoDDS}"
        *ngIf="!isGroupe && (edit || isModifierLeContenant || newprest.typeOperation)"
        (click)="editEvent(newprest, (addContenant && !isGroupe ? 6 : 5))" style="    white-space: nowrap;">
        <div class="col-sm-12 p-0 info2Ligne">
          <label> Opération </label>
          <span style="margin-bottom: 5px;" *ngIf="!isVidage">
            {{ newprest.typeOperation ? newprest.typeOperation.libelleObjetEntite : '' }}
          </span>
          <span style="margin-bottom: 5px;" *ngIf="isVidage">
            Contenant à vider
            <span *ngIf="newprest.parking"> {{newprest.parking}} </span>
          </span>
        </div>

      </div>
      <div class="col-sm-12" style="padding: 0">
        <div id="btn-Opdefault" class="col-sm-6"
          [ngClass]="{'div': !isVidage, 'disabledbutton': isVidage || notEditable || isMouvPraxy || isEcoDDS}"
          *ngIf="!isGroupe && (societe.operationBenneSupp && societe.operationBenneParDefaut && dataisOpSurBenneEnPlace && dataisOpSurBenneEnPlace.length &&
                defaultSelected && (defaultSelected.id !== 0 && defaultSelected.id !== 1) && (edit || isModifierLeContenant || newprest.champOperationDefaut))"
          (click)="editEvent(newprest, (addContenant && !isGroupe ? 6 : 5), '.champOperationDefaut')"
          style="    white-space: nowrap;">
          <label> Op. par défaut </label>
          <span style="margin-bottom: 5px;" *ngIf="!isVidage">
            {{ defaultSelectedDefaut ? defaultSelectedDefaut.libelleObjetEntite : '' }}
          </span>
        </div>
        <div id="btn-editPrestPro" class="col-sm-6"
          [ngClass]="{'div': !isVidage, 'disabledbutton': isVidage || notEditable || isMouvPraxy || isEcoDDS}"
          *ngIf="edit || isModifierLeContenant || (newprest.program || newprest.programation)"
          (click)="editEvent(newprest, (addContenant && !isGroupe ? 3 : 6))" style="    white-space: nowrap;">
          <label> Prestation programmée </label>
          <span style="margin-bottom: 5px;">
            {{ newprest.program ? 'OUI' : 'NON' }}
          </span>
        </div>
      </div>

      <div class="col-sm-12" style=" padding: 0;" *ngIf="edit || isModifierLeContenant || newprest.showdate"
        [ngClass]="{'disabledbutton': isVidage || notEditable}">
        <div id="btn-editDate" class="col-sm-6  {{ isVidage && isGroupe ? '' : 'div' }}"
          [ngClass]="{'disabledbutton': isMouvPraxy}" (click)="editEvent(newprest, (addContenant && !isGroupe ? 3 : 6))"
          style="    white-space: nowrap;">
          <label> Date </label>
          <!-- <div style="margin-bottom: 5px;"> {{ newprest.dateStart | date: 'dd/MM/yyyy' }} </div> -->
          <span style="margin-bottom: 5px;"> {{ common.isDate(newprest.dateStart) }} </span>
        </div>
        <div id="btn-editheure" class="col-sm-6  {{ isVidage && isGroupe ? '' : 'div' }}"
          (click)="editEvent(newprest, (addContenant && !isGroupe ? 3 : 6), 'h1')" style="    white-space: nowrap;">
          <label> Heure </label>
          <span style="margin-bottom: 5px;"> {{ hourMvt() }}
          </span>
        </div>
      </div>

      <div class="col-sm-12" style=" padding: 0;"
        *ngIf="societe.dateDemandeManuel && (edit || isModifierLeContenant || newprest.showdate)"
        [ngClass]="{'disabledbutton': isVidage || notEditable}">
        <div id="btn-editheure" class="col-sm-6  {{ isVidage && isGroupe ? '' : 'div' }}"
          (click)="editEvent(newprest, (addContenant && !isGroupe ? 3 : 6), '#dateDmd')" style=" white-space: nowrap;">
          <label> Date Demande </label>
          <span style="margin-bottom: 5px;"> {{newprest.dateDemandeManuel || ''}}</span>
        </div>
      </div>

      <div class="col-sm-12" style=" padding: 0;"
        *ngIf="societe.gestionDateMax && (edit || isModifierLeContenant || newprest.showdate)"
        [ngClass]="{'disabledbutton': isVidage || notEditable}">
        <div id="btn-editDatemax" class="col-sm-6  {{ (isVidage && isGroupe) || edit ? '' : 'div' }}"
          [ngClass]="{'disabledbutton': isMouvPraxy || isEcoDDS || edit}"
          (click)="editEvent(newprest, (addContenant && !isGroupe ? 3 : 6))" style="    white-space: nowrap;">
          <label> Date Max </label>
          <!-- <div style="margin-bottom: 5px;"> {{ newprest.dateStart | date: 'dd/MM/yyyy' }} </div> -->
          <span style="margin-bottom: 5px;"> {{ common.isDate(newprest.dateMaxStart) }} </span>
        </div>
      </div>
      <div class="col-sm-12" style=" padding: 0;" *ngIf="edit || isModifierLeContenant || newprest.showdate"
        [ngClass]="{'disabledbutton': isVidage || notEditable || isMouvPraxy}">
        <div id="btn-editDatetard" class="col-sm-6  {{ isVidage && isGroupe ? '' : 'div' }}"
          [ngClass]="{'disabledbutton': isEcoDDS}"
          (click)="editEvent(newprest, (addContenant && !isGroupe ? 3 : 6), 'h2')" style="    white-space: nowrap;">
          <label> Au + Tard </label>
          <span style="margin-bottom: 5px;"> {{ newprest.auPlusTard ? 'OUI' : 'NON' }}
          </span>
        </div>
        <div id="btn-editDuree" class="col-sm-6  {{ isVidage && isGroupe ? '' : 'div' }}"
          (click)="editEvent(newprest, (addContenant && !isGroupe ? 3 : 6), 'h2')" style="    white-space: nowrap;">
          <label> Durée </label>
          <span style="margin-bottom: 5px;"> {{ dureeMvt() }}
          </span>
        </div>
      </div>
      <!--  [ngClass]="{'div': !isVidage, 'disabledbutton': notEditable}" -->
      <div class="col-sm-12" style="padding: 0px"
        [ngClass]="{'disabledbutton': notEditable || isMouvPraxy || isEcoDDS}">
        <div id="btn-editSiteDeprest" class="col-sm-6 div" [ngClass]="{'disabledbutton': notEditable}"
          *ngIf="isShowSite && (edit || isModifierLeContenant || newprest.showsite)" (click)="editEvent(newprest, 7)">
          <label> Site de prestation </label>
          <div style="margin-bottom: 5px;">
            {{ newprest.sitePrest ? newprest.sitePrest.nom || newprest.sitePrest.libelleObjetEntite : '' }}
          </div>
        </div>
        <div id="btn-editprCmptDe" class="col-sm-6 div" [ngClass]="{'disabledbutton': notEditable}"
          *ngIf="isShowSite && (edit || isModifierLeContenant || newprest.showsite)"
          (click)="editEvent(newprest, 7, '.siteCA')">
          <label> Pour le compte de </label>
          <div style="margin-bottom: 5px;">
            {{ newprest.siteCA ? newprest.siteCA.nom || newprest.siteCA.libelleObjetEntite : '' }}
          </div>
        </div>
      </div>
      <div class="col-sm-12" style="padding: 0px"
        [ngClass]="{'disabledbutton': isVidage || notEditable || isMouvPraxy || isEcoDDS}">
        <div id="btn-editAcompte" class="col-sm-6" [ngClass]="{'div': !isVidage}"
          *ngIf="edit || isModifierLeContenant || (newprest.acompte && !newprest.acomptefocus)"
          (click)="editEvent(newprest, 8,'#acompte')" style="    white-space: nowrap;">
          <label> Acompte </label>
          <span style="margin-bottom: 5px;"> {{ newprest.acompte ? common.toFixed(newprest.acompte) : '' }} </span>
        </div>
        <div id="btn-editRefCont" class="col-sm-6" [ngClass]="{'div': !isVidage}"
          *ngIf="showContrat && (edit || isModifierLeContenant || (newprest.numContrat  && !newprest.contratfocus))"
          (click)="editEvent(newprest, 8, '#contrat')" style="    white-space: nowrap;">
          <div class="col-sm-12 p-0 info2Ligne">
            <label> Réf Contrat </label>
            <span style="margin-bottom: 5px;"> {{ newprest.numContrat }} </span>
          </div>

        </div>
      </div>
      <div class="col-sm-12" style="padding: 0px"
        [ngClass]="{'disabledbutton': isVidage || notEditable || isMouvPraxy || isEcoDDS}">
        <div id="btn-editContrat" class="col-sm-6" [ngClass]="{'div': !isVidage}"
          *ngIf="societe.ecogrc && (edit || isModifierLeContenant || (newprest.contratChamp))"
          (click)="editEvent(newprest, 8, '.contratChamp', true)" style="    white-space: nowrap;">
          <div class="col-sm-12 p-0 info2Ligne">
            <label> Contrat </label>
            <span style="margin-bottom: 5px;"> {{newprest.contratChamp && newprest.contratChamp.id ?
              ((newprest.contratChamp.numContrat || '') + ':' + (newprest.contratChamp.reference || '')) : 'Aucun'}}
            </span>
          </div>

        </div>
        <div id="btn-editprst" class="col-sm-6" [ngClass]="{'div': !isVidage}"
          *ngIf="societe.ecogrc && (edit || isModifierLeContenant || (newprest.prestation))"
          (click)="editEvent(newprest, 8, '.prestationChamp', true)" style="    white-space: nowrap;">
          <label> Prestation </label>
          <span style="margin-bottom: 5px;"> {{ newprest.prestation ? ((newprest.prestation.date ||
            newprest.prestation.libelleObjetEntite || '')) : '' }} </span>
        </div>
      </div>
      <div class="col-sm-12" style="padding: 0px"
        [ngClass]="{'disabledbutton': isVidage || notEditable || isMouvPraxy || isEcoDDS}">
        <div id="btn-nBonMan" class="col-sm-6" [ngClass]="{'div': !isVidage}"
          *ngIf="edit || isModifierLeContenant || (newprest.numBonManuel && !newprest.numBonfocus)"
          (click)="editEvent(newprest, 8, '#numbon')" style="    white-space: nowrap;">
          <label> N° Bon manuel </label>
          <span style="margin-bottom: 5px;"> {{ newprest.numBonManuel }} </span>
        </div>
        <div id="btn-nBSDMan" class="col-sm-6" [ngClass]="{'div': !isVidage}"
          *ngIf="edit || isModifierLeContenant || (newprest.numBSDD && !newprest.numBSDDfocus)"
          (click)="editEvent(newprest, 8, '#numbsdd')" style="    white-space: nowrap;">
          <label> N° BSD manuel </label>
          <span style="margin-bottom: 5px;"> {{ newprest.numBSDD }} </span>
        </div>
      </div>
      <div class="col-sm-12" style="padding: 0px" *ngIf="isAmiante && !isGroupe"
        [ngClass]="{'disabledbutton': isVidage || notEditable || isMouvPraxy || isEcoDDS}">

        <div id="btn-nBSDMan" class="col-sm-6" [ngClass]="{'div': !isVidage}"
          *ngIf="edit || isModifierLeContenant || (newprest.numScelle && !newprest.numScellefocus)"
          (click)="editEvent(newprest, 8, '#numScelle')" style="    white-space: nowrap;">
          <label>Num Scellé </label>
          <span style="margin-bottom: 5px;"> {{ newprest.numScelle }} </span>
        </div>
      </div>
      <div *ngIf="isChoixCamionCreationMouv" class="col-sm-12" style="padding: 0px"
        [ngClass]="{'disabledbutton': isVidage || notEditable || isMouvPraxy || isEcoDDS}">
        <div id="btn-editPeriod" class="col-sm-6" [ngClass]="{'div': !isVidage}"
          *ngIf="edit || isModifierLeContenant || (newprest.periode && !newprest.periodefocus)"
          (click)="editEvent(newprest, 8, '.periode',true)" style="    white-space: nowrap;">
          <label> Période </label>
          <span style="margin-bottom: 5px;"> {{ newprest.periode ? newprest.periode.libelle ||
            newprest.periode.libelleObjetEntite : '' }} </span>
        </div>

        <div id="btn-editCam" class="col-sm-6" [ngClass]="{'div': !isVidage}"
          *ngIf="edit || isModifierLeContenant || (newprest.camion && !newprest.camionfocus)"
          (click)="editEvent(newprest, 8, '.exugrp_cam')" style="    white-space: nowrap;">
          <label> Camion </label>
          <span style="margin-bottom: 5px;"> {{ getTextCamion(newprest.camion) }} </span>
        </div>
      </div>
      <div class="col-sm-12" style="padding: 0px" *ngIf="societe.ecobennesEquipe"
        [ngClass]="{'disabledbutton': isVidage || notEditable || isMouvPraxy || isEcoDDS}">
        <div id="btn-editEqip" class="col-sm-6" style="    white-space: nowrap;" [ngClass]="{'div': !isVidage}"
          *ngIf="edit || isModifierLeContenant || (step >= 10)" (click)="editEvent(newprest, 8)">
          <label> Equipe </label>
          <span style="margin-bottom: 5px;"> {{ newprest.modeEquipe ? 'OUI' : 'NON' }} </span>
        </div>
      </div>
      <div class="col-sm-12" style="padding: 0px" [ngClass]="{'disabledbutton': notEditable || isEcoDDS}">
        <div id="btn-editInfoFac" class="col-sm-6  {{ isVidage && isGroupe ? '' : 'div' }}"
          *ngIf="edit || isModifierLeContenant || (newprest.infoFact && !newprest.infofactfocus)"
          (click)="editEvent(newprest, 9)" popover="{{newprest.infoFact}}" [container]="null"
          [containerClass]="'contenantPopoevr'" [placement]="'top'" triggers="mouseenter:mouseleave mouseenter:click">
          <label> Infos Fact </label>
          <div class="col-sm-12 p-0 info2Ligne" style="margin-bottom: 5px;  -webkit-box-orient: vertical; ">{{
            newprest.infoFact }}</div>
        </div>
        <div id="btn-editInfoPrs" class="col-sm-6  {{ isVidage && isGroupe ? '' : 'div' }}"
          *ngIf="edit || isModifierLeContenant || (newprest.infoNextMouv && !newprest.infomvtfocus)"
          (click)="editEvent(newprest, 9, '#infomvt')" popover="{{newprest.infoNextMouv}}" [container]="null"
          [containerClass]="'contenantPopoevr'" [placement]="'top'" triggers="mouseenter:mouseleave mouseenter:click">
          <label> Infos prestation </label>
          <div class="col-sm-12 p-0 info2Ligne" style="margin-bottom: 5px; -webkit-box-orient: vertical; "> {{
            newprest.infoNextMouv }} </div>
        </div>
      </div>
      <div class="col-sm-12 {{ isVidage && isGroupe ? '' : 'div' }}"
        [ngClass]="{'disabledbutton': notEditable || isMouvPraxy || isEcoDDS}" style="padding: 0px">
        <div id="btn-editInfoCont" class="col-sm-6"
          *ngIf="edit || isModifierLeContenant || (newprest.infos && !newprest.infosuppfocus)"
          (click)="editEvent(newprest, 9, '#infosup')" popover="{{newprest.infos}}" [container]="null"
          [containerClass]="'contenantPopoevr'" [placement]="'top'" triggers="mouseenter:mouseleave mouseenter:click">
          <label> Infos contenant </label>
          <div class="col-sm-12 p-0 info2Ligne" style="margin-bottom: 5px;  -webkit-box-orient: vertical; "> {{
            newprest.infos }} </div>
        </div>
      </div>
    </div>
    <!-- <div class="col-sm-12 btn-foot">
      <button class="pull-left btn-close" id="log" *ngIf="edit && !isHisto" (click)="getLogs(newprest)">
        Logs
      </button>
      <button class="btn-close" id="supprimer" *ngIf="edit && !isHisto && isDroitSuppMouv" (click)='initSupprimerBon()'>
        Supprimer
      </button>
    </div> -->
  </div>
  <div class="fiche" #fiche id="fiche"
    [ngStyle]="{'width': (showFichechantier || showFicheclt || isJourFerie || isSuspension || isClickFacturation || isProgrammation || isModeEquipe) ? '552px' : '0'}">
    <div class="ficheclt" *ngIf="showFichechantier" [ngStyle]="{'right': (modifier) ? '550px' : '550px'}">
      <app-fiche-chantier [chantier]="showFichechantier" [client]="newprest.client" [edit]="isEditChantier"
        (hidefunction)="hideChantier()" (validefunction)="updateChantier($event)" (addfunction)="createChantier($event)"
        [add]="addChantier"></app-fiche-chantier>
      <!--[disablemodif]="edit"-->
    </div>
    <div class="fichechantier" *ngIf="showFicheclt" [ngStyle]="{'right': (modifier) ? '550px' : '550px'}">
      <app-fiche-client [position]="true" [client]="addClient ? '' : newprest.client.id"
        (hidefunction)="addClient ? showFicheCltadd() : showFiche()"
        (addfunction)="addClient ? afterAddClt($event) : false" [add]="addClient"></app-fiche-client>
    </div>
    <div class="ficheclt" *ngIf="isClickFacturation" [ngStyle]="{'right': (modifier) ? '550px' : '550px'}">
      <app-location-facturation [contenant]="contenantFact" [client]="client" (hidefunction)="showFacturation()"
        (validefunction)="saveLocationFact($event)"></app-location-facturation>
    </div>
    <div class="ficheclt" *ngIf="isProgrammation" [ngStyle]="{'right': (modifier) ? '550px' : '550px'}">
      <app-programmations [programme]="mouvBenneProgramme" (savePeriode)="savePeriodePgm($event)"
        (hidefunction)="showProgrammation()" (saveFerier)="saveJourFerier($event)"
        (saveSusp)="saveSuspension($event)"></app-programmations>
    </div>
    <div class="ficheclt" *ngIf="isModeEquipe" style="width: 750px;"
      [ngStyle]="{'right': (modifier) ? '550px' : '550px'}">
      <app-choix-equipes [mouvement]="objEquipe" [date]="newprest.dateStart" (save)="saveEquipe($event)"
        (hidefunction)="showEquipe()"></app-choix-equipes>
    </div>
  </div>
  <div *ngIf="isAddContTournee">
    <app-add-contenant-tournees [info]="detailTournee" (close)="toogleSlideTournee()"
      (updateFct)="addContenantTournee($event)">
    </app-add-contenant-tournees>
  </div>
</div>

<div class="spinner" *ngIf="showSpinner===true">
  <div class="sk-fading-circle">
    <div class="sk-circle1 sk-circle"></div>
    <div class="sk-circle2 sk-circle"></div>
    <div class="sk-circle3 sk-circle"></div>
    <div class="sk-circle4 sk-circle"></div>
    <div class="sk-circle5 sk-circle"></div>
    <div class="sk-circle6 sk-circle"></div>
    <div class="sk-circle7 sk-circle"></div>
    <div class="sk-circle8 sk-circle"></div>
    <div class="sk-circle9 sk-circle"></div>
    <div class="sk-circle10 sk-circle"></div>
    <div class="sk-circle11 sk-circle"></div>
    <div class="sk-circle12 sk-circle"></div>
  </div>
</div>

<ng-template #changedate>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Raison report </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal(); closeFunction();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body moduleEcobennes moduleEcobennes" style="height: auto">
    <div class="col-sm-12">
      <div class="col-sm-12" style="padding: 0">
        <label for="from"> Raison report : </label>
        <textarea class="form-control" rows="3" [(ngModel)]="raisonReport"></textarea>
      </div>
    </div>
    <div class="text-right col-sm-12" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="updateDateWeek();"> Valider
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal(); closeFunction();"> Fermer</button>
    </div>
  </div>
</ng-template>


<ng-template #changedateBon>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Raison report </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal(); raisonReport = ''">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body moduleEcobennes moduleEcobennes" style="height: auto">
    <div class="col-sm-12">
      <div class="col-sm-12" style="padding: 0">
        <label for="from"> Raison report : </label>
        <textarea class="form-control" rows="3" [(ngModel)]="raisonReport"></textarea>
      </div>
    </div>
    <div class="text-right col-sm-12" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal();reportBon();"> Valider
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal(); raisonReport = '';"> Fermer</button>
    </div>
  </div>
</ng-template>


<ng-template #confirmeImpBonSansChauffeur>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Confirmation impression</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body moduleEcobennes" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg">Il n'y a pas de chauffeur positionné sur le camion {{
          immatriculationCamionSsChauffeur }}</label>
        <label class="cofirmemsg"> Souhaitez vous tout de même lancer l'impression ? </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal(); afficherChoixFormatPerso();">
        OUI
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal()"> NON</button>
    </div>
  </div>
</ng-template>

<ng-template #programConfirme>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Confirmation </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body moduleEcobennes" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg"> Vous êtes en train de modifier une prestation programmée. </label>
        <label class="cofirmemsg"> Voulez-vous appliquer les modifications sur toutes les prestations du
          programme? </label>
        <label class="cofirmemsg"> Attention. Cette opération peut prendre plusieurs dizaines de secondes
        </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider"
        (click)="updateAll = true;common.closeModal(); saveMouvement();"> OUI
      </button>
      <button type="button" class=" btn-close" (click)="updateAll = false; common.closeModal(); saveMouvement();">
        NON
      </button>
    </div>
  </div>
</ng-template>
<ng-template #formatEtiquetteADR>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Choisissez un format d'impression </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body moduleEcobennes" style="height: auto">
    <div>
      <ul class="list-group listeformat" *ngIf="listFormatEtiquetteADR && listFormatEtiquetteADR.length">
        <li class="list-group-item" *ngFor="let item of listFormatEtiquetteADR" (click)="formatADRSelected = item"
          [ngClass]="{'formatselected': formatADRSelected.id === item.id}">
          Format : {{ item.libelleObjetEntite }} <br />
          Description: {{ item.description }}
        </li>
      </ul>
      <span *ngIf="!listFormatEtiquetteADR.length"> Aucun format disponible. Veuillez en définir au moins un </span>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider"
        *ngIf="!listFormatEtiquetteADR || listFormatEtiquetteADR.length === 0" (click)="common.closeModal()">
        Fermer
      </button>
      <button type="button" class=" btn-close btn-valider" *ngIf="listFormatEtiquetteADR.length > 0"
        (click)="common.closeModal();processImprimerADR();">
        Valider
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal()"> Annuler</button>
    </div>
  </div>
</ng-template>

<ng-template #format>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Choix du format </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body moduleEcobennes" style="height: auto">
    <div>
      <ul class="list-group listeformat" *ngIf="formatPerso.length">
        <li class="list-group-item" *ngFor="let item of formatPerso" (click)="formatprs = item"
          [ngClass]="{'formatselected': formatprs.id === item.id}">
          {{ item.libelleObjetEntite }}
        </li>
      </ul>

      <span *ngIf="!formatPerso.length"> Aucun format disponible. Veuillez en définir au moins un </span>

    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" *ngIf="!formatPerso.length" (click)="common.closeModal();common.isRedirectOpenDocImp = false">
        Fermer
      </button>
      <button type="button" class=" btn-close btn-valider" *ngIf="formatPerso.length" (click)="imprimerBon();">
        Valider
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal()"> Annuler</button>
    </div>
  </div>
</ng-template>

<ng-template #formatBonParMail>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Choix du format </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body moduleEcobennes" style="height: auto">
    <div>
      <ul class="list-group listeformat" *ngIf="formatPerso.length">
        <li class="list-group-item" *ngFor="let item of formatPerso" (click)="formatprs = item"
          [ngClass]="{'formatselected': formatprs.id === item.id}">
          {{ item.libelleObjetEntite }}
        </li>
      </ul>

      <span *ngIf="!formatPerso.length"> Aucun format disponible. Veuillez en définir au moins un </span>

    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" *ngIf="!formatPerso.length" (click)="common.closeModal()">
        Fermer
      </button>
      <button type="button" class=" btn-close btn-valider" *ngIf="formatPerso.length" (click)="envoyerBonsParMail();">
        Valider
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal()"> Annuler</button>
    </div>
  </div>
</ng-template>

<ng-template #dialogueSuppression>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Motif de la suppression </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal(); closeFunction();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body moduleEcobennes moduleEcobennes" style="height: auto">
    <div class="col-sm-12">
      <div class="col-sm-12" style="padding: 0">
        <label for="from"> Veuillez saisir le motif de la suppression : </label>
        <textarea class="form-control" rows="3" [(ngModel)]="raisonSuppression"></textarea>
      </div>
    </div>
    <div class="text-right col-sm-12" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="supprimerBon();"> Ok
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal(); closeFunction();"> Annuler</button>
    </div>
  </div>
</ng-template>

<ng-template #dialogueConfirmSuppresionGroupe>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Confirmation </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal(); closeFunction();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body moduleEcobennes" style="height: auto">
    <div class="col-sm-12">
      <div class="col-sm-12" style="padding: 0">
        <span>
          Voulez-vous supprimer ce groupe?
        </span>
      </div>
    </div>
    <div class="text-right col-sm-12" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider"
        (click)="onClickOkSupprimeGroupe(); common.closeModal(); closeFunction();"> Ok
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal(); closeFunction();"> Annuler</button>
    </div>
  </div>
</ng-template>

<ng-template #msg>
  <div class="modal-body moduleEcobennes" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg"> {{ error }} </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="closeModalError()"> Fermer</button>
    </div>
  </div>
</ng-template>

<ng-template #msgFormat>
  <div class="modal-body moduleEcobennes" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg"> {{ error }} </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal();"> Fermer</button>
    </div>
  </div>
</ng-template>

<ng-template #msgFormatTrackdechets>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Erreur TrackDechets</h4>
  </div>
  <div class="modal-body moduleEcobennes" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg"> {{ error }} </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal();"> Fermer</button>
    </div>
  </div>
</ng-template>

<ng-template #mail>
  <app-panneau-mail [data]="datamail" (validerPanneauMail)="validerPanneauMail($event)" [aUnSignature]="aUnSignature">
  </app-panneau-mail>
</ng-template>

<ng-template #loading>
  <div class="modal-body moduleEcobennes" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg"> Envoi en cours ... </label>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #loadingSygetrack>
  <!-- <ng-template [ngIf]="common.isCLS()">
    <div class="modal-header">
      <h4 class="modal-title pull-left">CLS </h4>
    </div>
    <div class="modal-body moduleEcobennes" style="height: auto">
      <div>
        <div class="col-sm-12" id="container-msg-sygetrack">
          <label class="cofirmemsg" style="font-family: Roboto-Black; font-size: 15px; text-align: justify"
            [innerHTML]="msgSygetrack ? msgSygetrack : 'Attente du retour de CLS'"></label>
        </div>
      </div>

      <div class="text-right" style="margin-top: 15px;" *ngIf="msgSygetrack">
        <button type="button" class=" btn-close btn-valider" (click)="closeSygetrack()"> Fermer </button>
      </div>
    </div>
  </ng-template>
  <ng-template [ngIf]="!common.isCLS()"> -->
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ nomInformatiqueImbrique }} </h4>
  </div>
  <div class="modal-body moduleEcobennes" style="height: auto">
    <div>
      <div class="col-sm-12" id="container-msg-sygetrack">
        <label class="cofirmemsg" style="font-family: Roboto-Black; font-size: 15px; text-align: justify"
          [innerHTML]="msgSygetrack ? msgSygetrack : 'Attente du retour de ' + nomInformatiqueImbrique"></label>
      </div>
    </div>

    <div class="text-right" style="margin-top: 15px;" *ngIf="msgSygetrack">
      <button type="button" class=" btn-close btn-valider" (click)="closeSygetrack()"> Fermer </button>
    </div>
  </div>
  <!-- </ng-template> -->
</ng-template>

<ng-template #dialogueQteADR>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Options impression ADR </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body moduleEcobennes" style="height: auto">
    <div class="col-sm-12 ligneBon" style="padding: 0; height: 300px;">
      <ngx-datatable class="material" style="height:100%;" [rows]="listBonImp" [columnMode]="'force'"
        [headerHeight]="'30'" [footerHeight]="0" [rowHeight]="'30'" [selectionType]="'single'"
        [messages]="{emptyMessage: loadingIndicatorHisto ? 'Chargement ...' : 'Pas de bon à afficher'}"
        [loadingIndicator]="loadingIndicatorHisto">

        <ngx-datatable-column name="numBon" prop="NUM_BON" [width]="80">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader" (click)="sort()">
              <span class="uppercase"> N° bon</span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            <div> {{value || ''}} </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Contenant" prop="CODE_ARTICLE">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader" (click)="sort()">
              <span class="uppercase"> Article </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            <div>
              {{ value }} / {{row.LIBELLE_ARTICLE || ''}}
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="remorque" prop="tarif" [width]="60">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader" (click)="sort()">
              <span class="uppercase"> Qté imp. </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
            <div class="col-sm-12">
              <input type="number" id="qte{{rowIndex}}" [decimals]="0" class="input detailfact form-control text-right"
                placeholder="qté" [(ngModel)]="row.quantite" autocomplete="off">
            </div>
          </ng-template>
        </ngx-datatable-column>

      </ngx-datatable>
    </div>
    <div class="text-right col-m-12" style="margin-top: 15px; padding: 0;">
      <button type="button" class=" btn-close btn-valider" (click)=" common.closeModal(); imprissionTousADR();">
        imprimer
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal()"> Annuler</button>
    </div>
  </div>
</ng-template>


<ng-template #confirmaFIPDND>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Impresion FIP DND : </h4>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg"> Souhaitez vous imprimer une FIP pour les DND ? </label>
      </div>
    </div>
    <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal(); getFormatPersoFIP(37);">
        OUI
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal(); nextClose();"> NON</button>
    </div>
  </div>
</ng-template>

<ng-template #confirmaFIPDD>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Impresion FIP DD : </h4>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg"> Souhaitez vous imprimer une FIP pour les DD ? </label>
      </div>
    </div>
    <div class="text-right col-sm-12" style="margin-top: 15px; padding: 0px;">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal();getFormatPersoFIP(38);">
        OUI
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal();nextClose();"> NON</button>
    </div>
  </div>
</ng-template>


<ng-template #formatPesroFIP>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Choix du format </h4>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <ul class="list-group listeformat" *ngIf="formatPerso.length">
        <li class="list-group-item" *ngFor="let item of formatPerso" (click)="formatprs = item"
          [ngClass]="{'formatselected': formatprs.id === item.id}">
          {{ item.libelleObjetEntite }}
        </li>
      </ul>

      <span *ngIf="!formatPerso.length"> Aucun format disponible. Veuillez en définir au moins un </span>

    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" *ngIf="!formatPerso.length"
        (click)="common.closeModal(); nextClose();">
        Fermer
      </button>
      <button type="button" class=" btn-close btn-valider" *ngIf="formatPerso.length"
        (click)="common.closeModal();printFIP();">
        Valider
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal(); nextClose();"> Annuler</button>
    </div>
  </div>
</ng-template>